webpackJsonp([62],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('app-header',{attrs:{"title":_vm.$route.meta.title,"logo-url":_vm.logoUrl,"is-visible":!_vm.isVisible},on:{"open":_vm.toggleSidebar}}),_vm._v(" "),_c('app-sidebar',{attrs:{"toggle":_vm.isVisible},on:{"active-route":_vm.getRoutes,"toggle-sidebar":_vm.changeToggle}}),_vm._v(" "),_c('section',{staticClass:"section-margin"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb9b50f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__ = __webpack_require__(1003);
function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb9b50f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb9b50f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-filter media-print"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__ = __webpack_require__(1006);
function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a12b434a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_date_mask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a12b434a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_date_mask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"background-color":"white","hide-details":"","label":_vm.label,"placeholder":"__/__/___","value":_vm.picker},on:{"input":_vm.onInput,"change":function($event){_vm.onChange($event, 'change')}}},'v-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a131be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__ = __webpack_require__(1012);
function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38a131be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a131be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3f2194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__ = __webpack_require__(1011);
function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a3f2194"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3f2194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"id":'column-' + _vm.column.id}},[(_vm.column.isEditable)?_c('span',[(_vm.column.showInput)?_c('span',[_c('input',{ref:("colheader" + (_vm.column.id)),staticClass:"column-input",attrs:{"type":"text","placeholder":_vm.column.name},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.toggleInput(_vm.column)},"input":function($event){_vm.$emit('column-input', { event: $event, column: _vm.column })}}})]):(_vm.column.tooltip)?_c('span',{staticClass:"column-edit-container"},[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t\t")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])],1):_c('span',{staticClass:"column-edit-container"},[_vm._v("\n\t\t\t"+_vm._s(_vm.column.name)+"\n\t\t\t"),_c('button',{on:{"click":function($event){_vm.toggleInput(_vm.column)}}},[_c('img',{attrs:{"height":"11","title":"Editar todas las filas a la vez","width":"11","src":(_vm.$imageUrl + "/edit-table.svg")}})])])]):(_vm.column.tooltip)?_c('span',[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.column.name))]),_vm._v("\n\t\t\t"+_vm._s(_vm.column.tooltip)+"\n\t\t")])],1):_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.column.name)+"\n\t")]),_vm._v(" "),(_vm.column.isSortable)?_c('button',{staticClass:"sortable-button",on:{"click":function($event){_vm.onColumnSortable(_vm.column)}}},[(_vm.column.isSortable.down)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_down\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.column.isSortable.up)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("\n\t\t\tarrow_drop_up\n\t\t")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table-list",attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('thead',{style:(("color:" + (_vm.$appColors.primary)))},[(_vm.inputSearch || _vm.filterColumns || _vm.includeFilter || _vm.addButton)?_c('tr',[_c('th',{class:("text-xs-" + _vm.direction),attrs:{"colspan":_vm.totalVisibleColumns}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-space-between":""}},[_c('v-flex',{attrs:{"text-xs-left":""}},[_c('div',{staticClass:"table-title info--text"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-end":""}},[(_vm.inputSearch)?_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],style:(("color:" + (_vm.$appColors.info))),attrs:{"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows($event)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":"https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/magnifying-glass.svg","alt":"Buscador","height":"20","width":"20"}})]):_vm._e(),_vm._v(" "),(_vm.iconEmployee)?_c('div',{staticClass:"new-area center",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"text":"Nuevo Empleado","icon":"person_add","color":"primary"},on:{"click-icon":function($event){_vm.$emit('open-modal')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconArea)?_c('div',{staticClass:"d-flex new-area",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"text":"Nueva Área","img":"https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/group-19-copy.svg","color":"primary"},on:{"click-icon":function($event){_vm.$emit('open-area')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconEmployee)?_c('div',{staticClass:"new-area center",attrs:{"xs2":""}},[_c('app-tooltip-button',{attrs:{"img":"https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/group-16-(1).svg","text":"Asignar Área","color":"info","disabled":_vm.disabledAssign},on:{"click-icon":function($event){_vm.$emit('open-area')}}})],1):_vm._e(),_vm._v(" "),(_vm.iconExcel)?_c('div',{staticClass:"new-area center",attrs:{"xs2":"","text-xs-center":""}},[_vm._t("excel")],2):_vm._e()])],1),_vm._v(" "),(_vm.filterColumns || _vm.includeFilter || _vm.addButton)?_c('v-flex',[(_vm.filterColumns)?_c('v-menu',{attrs:{"offset-y":"","nudge-left":97,"max-height":"300","content-class":"columns-menu","fixed":"","close-on-content-click":false},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('button',{style:(("background-color: " + (_vm.$appColors.secondary) + ";")),attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',[_vm._v("view_column")])],1),_vm._v(" "),_c('div',[_vm._l((_vm.columns),function(column){return [(!column.flagVisible)?_c('v-checkbox',{key:column.id,staticStyle:{"background":"white"},attrs:{"label":column.name,"hide-details":"","color":"success"},model:{value:(column.checked),callback:function ($$v) {_vm.$set(column, "checked", $$v)},expression:"column.checked"}}):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"apply text-xs-center"},[_c('button',{style:(("background-color: " + (_vm.$appColors.success) + ";")),on:{"click":_vm.toggleColumns}},[_vm._v("Aplicar")])])],2)]):_vm._e(),_vm._v(" "),(_vm.includeFilter)?_c('button',{staticClass:"vertical-align-middle",style:(("background-color: " + (_vm.$appColors.success) + ";")),attrs:{"type":"button"},on:{"click":_vm.tableOption}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("filter_list")])],1):_vm._e(),_vm._v(" "),(_vm.addButton)?_c('button',{style:(("background-color: " + (_vm.$appColors.success) + ";")),attrs:{"type":"button"},on:{"click":_vm.addOption}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.selectable)?_c('th',{staticClass:"text-xs-center td-check"},[_c('input',{staticClass:"input-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.checkAll,"checked":_vm.checkAll},on:{"change":function($event){_vm.selectedAll($event)}}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return _c("table-column-item",{directives:[{name:"show",rawName:"v-show",value:(column.visible),expression:"column.visible"}],key:column.id,tag:"th",staticClass:"primary--text text-xs-left",class:column.flagVisible ? 'text-xs-center' : 'text-xs-left',attrs:{"column":column}})})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rows),function(row){return _c('tr',{key:row[_vm.keyValue],staticClass:"info--text",class:{ 'row-checked' : row.isSelected},on:{"click":function($event){_vm.rowIsSelected(row)}}},[(_vm.selectable)?_c('td',{staticClass:"td-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.isSelected),expression:"row.isSelected"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","disabled":_vm.dispatchDetail && (row.flagDispatch > 0)},domProps:{"checked":Array.isArray(row.isSelected)?_vm._i(row.isSelected,null)>-1:(row.isSelected)},on:{"change":function($event){var $$a=row.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(row, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(row, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(row, "isSelected", $$c)}}}})]):_vm._e(),_vm._v(" "),_vm._t("rows",null,{row:row})],2)})],2),_vm._v(" "),_c('tfoot',{staticClass:"table-pagination"},[(_vm.mainList && _vm.rows.length > 0)?_c('tr',[_c('td',{staticClass:"text-xs-right info--text",attrs:{"colspan":_vm.totalVisibleColumns}},[_c('input',{staticClass:"search-input unique-input",attrs:{"type":"text"},domProps:{"value":_vm.currentPage},on:{"input":function($event){_vm.selectPage($event.target.value)}}}),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('a',{key:index,class:{ 'active-page': page === _vm.currentPage },on:{"click":function($event){_vm.selectPage(page)}}},[_vm._v(_vm._s(page))])}),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('a',{on:{"click":_vm.selectLastPage}},[_vm._v(">>")])],2)]):_vm._e(),_vm._v(" "),(_vm.rows.length === 0)?_c('tr',[_c('td',{staticClass:"info--text",style:(!_vm.mainList ?
					'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
					'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'),attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticClass:"info--text",staticStyle:{"text-align":"center","margin":"5px 0 0 5px"}},[_vm._v("\n\t\t\t\t\tNo hay información que mostrar\n\t\t\t\t")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82a97be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(1014);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82a97be4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","flat":"","icon":"","small":"","color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon($event)}},slot:"activator"},[(_vm.icon)?[_c('v-icon',{style:(_vm.isListAll),attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])]:[_c('img',{attrs:{"src":_vm.img,"alt":"text","height":_vm.size}})]],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf64f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__ = __webpack_require__(1017);
function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf64f49e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf64f49e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header-page pl-5 media-print",style:(("border-bottom: 2px solid " + (_vm.$appColors.success) + ";"))},[_c('h1',{staticClass:"header-page-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.toShow)?_c('div',{staticClass:"header-page-actions"},[(_vm.exportToPdf)?_c('v-btn',{staticClass:"header-page-download-document primary mr-2",on:{"click":function($event){$event.preventDefault();return _vm.downloadDispatch($event)}}},[_c('img',{staticClass:"align-img",attrs:{"src":(_vm.$imageUrl + "/icon-export-pdf.svg"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.showExcel)?_c('v-btn',{staticClass:"header-page-download-document primary",on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/fill-1.svg"),"alt":"download","height":"17"}})]):_vm._e(),_vm._v(" "),(_vm.showClean)?_c('v-btn',{staticClass:"btn-action",attrs:{"dark":""},on:{"click":function($event){_vm.$emit('on-clean')}}},[_vm._v("\n\t\t\tLimpiar\n\t\t")]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.quotation || _vm.sale)?_c('div',{staticClass:"header-page-actions translate"},[_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.downloadDocument}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/download.svg"),"alt":"download","height":"17"}})]),_vm._v(" "),_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.print}},[_c('img',{attrs:{"src":(_vm.$imageUrl + "/print.svg"),"alt":"download","height":"17"}})])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505ab6c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505ab6c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-sidebar"},[_c('v-container',{staticClass:"grid-list-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f91a56c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__ = __webpack_require__(1023);
function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f91a56c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f91a56c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-modal",style:(("border:1px solid " + (_vm.$appColors.info)))},[_c('div',{staticClass:"footer-container"},[(!_vm.hidden)?_c('v-btn',{staticClass:"btn-action mr-1",attrs:{"type":"button","color":"error"},on:{"click":_vm.cancelModal}},[_vm._v("\n\t\t\t"+_vm._s(_vm.cancelText)+"\n\t\t")]):_vm._e(),_vm._v(" "),(!_vm.hiddenSaveBtn)?_c('v-btn',{staticClass:"btn-action ml-1",attrs:{"type":"button","color":_vm.successColor,"disabled":_vm.isLoading},on:{"click":_vm.setInfo}},[_vm._v("\n\t\t\t"+_vm._s(_vm.successText)+"\n\t\t")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return diff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSlugify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUuidName; });
/* unused harmony export getFactorIdsToCompare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFactorCombinations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return factorWeighingCompletedCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return factorWeighingIsCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combinationsAreFilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return factorWeighingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return totalSumWeighings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPercentageByValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPercentageValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return factorIsSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generateWeighingComparison; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFactorsToCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addWeighWith; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(31);



var diff = function diff(a, b) {
	return a.localeCompare(b);
};

var getSlugify = function getSlugify(value) {
	return __WEBPACK_IMPORTED_MODULE_0_slugify__(value, {
		lower: true,
		remove: /[^\w\s]/gi
	});
};

var addUuidName = function addUuidName(factor) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])('uuid', getSlugify(factor.name), factor);
};

var getFactorIdsToCompare = function getFactorIdsToCompare(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(function () {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["q" /* filter */])(function (item) {
			return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* has */])(factor.uuid, item);
		}, combinations || []);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["D" /* keys */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["t" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_4" /* without */])(factor.uuid, __WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* __ */]))(factor);
};

var getFactorCombinations = function getFactorCombinations(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["q" /* filter */])(function (item) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* has */])(factor.uuid, item);
	}, combinations || []);
};

var factorWeighingCompletedCount = function factorWeighingCompletedCount(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(function (factorItem) {
		return getFactorCombinations(factorItem, combinations);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["q" /* filter */])(function (item) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* all */])(function (x) {
			return !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* isNil */])(x);
		}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["_2" /* values */])(item));
	}), __WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* length */])(factor);
};

var factorWeighingIsCompleted = function factorWeighingIsCompleted(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["p" /* equals */])(factorWeighingCompletedCount(factor, combinations), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["F" /* length */])(getFactorCombinations(factor, combinations)));
};

var combinationsAreFilled = function combinationsAreFilled(combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["_2" /* values */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["t" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["g" /* any */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* isNil */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["J" /* not */])(combinations);
};

var factorWeighingSum = function factorWeighingSum(factor, combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(function () {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["O" /* pluck */])(factor.uuid, combinations || []);
	}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* reject */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* isNil */]), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["U" /* reduce */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["b" /* add */], 0))(factor);
};

var totalSumWeighings = function totalSumWeighings(combinations) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["_2" /* values */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["t" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* reject */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* isNil */]), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["U" /* reduce */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["b" /* add */], 0))(combinations);
};

var getPercentageByValue = function getPercentageByValue(value, total) {
	if (total > 0) {
		return (value * 100 / total).toFixed(0);
	}
	return 0;
};

var getPercentageValue = function getPercentageValue(percentage, total) {
	if (total > 0) {
		return (percentage * total / 100).toFixed(0);
	}
	return 0;
};

var factorIsSelected = function factorIsSelected(selectedFactors, factor) {
	return !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["C" /* isNil */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* propEq */])('uuid', factor.uuid), selectedFactors));
};

var existCombination = function existCombination(combination, combinationList) {
	var foundIndex = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* findIndex */])(function (combinationItem) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["p" /* equals */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["X" /* sort */])(diff, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["D" /* keys */])(combination)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["X" /* sort */])(diff, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["D" /* keys */])(combinationItem)));
	}, combinationList);
	return foundIndex > 0;
};

var generateWeighingComparison = function generateWeighingComparison(selectedList) {
	var combinationList = [];
	Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["u" /* forEach */])(function (factor) {
		Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["u" /* forEach */])(function (compareFactor) {
			var factorUuid = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Q" /* prop */])('uuid', factor);
			var compareFactorUuid = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Q" /* prop */])('uuid', compareFactor);
			if (factorUuid !== compareFactorUuid) {
				var combination = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(factorUuid, null), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])(compareFactorUuid, null))({});
				if (!existCombination(combination, combinationList)) {
					combinationList = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* append */])(combination, combinationList);
				}
			}
		}, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Y" /* tail */])(selectedList));
	}, selectedList);
	return combinationList;
};

var getFactorsToCompare = function getFactorsToCompare(factor, combinations, selectedFactors) {
	var factorToCompareIds = getFactorIdsToCompare(factor, combinations);
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["q" /* filter */])(function (factorItem) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["z" /* includes */])(factorItem.uuid, factorToCompareIds) && !factorWeighingIsCompleted(factorItem, combinations);
	}, selectedFactors);
};

var addWeighWith = function addWeighWith(selectedFactors, combinations) {
	var findElement = function findElement(uuid) {
		var foundIndex = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["s" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["R" /* propEq */])('uuid', uuid), selectedFactors);
		return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["Q" /* prop */])(foundIndex, selectedFactors);
	};

	var restCombinations = combinations;
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(function (factor) {
		var newFactor = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["j" /* assoc */])('weighWith', Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["q" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* has */])(factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["D" /* keys */]), __WEBPACK_IMPORTED_MODULE_1_ramda__["t" /* flatten */], Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["p" /* equals */])(__WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* __ */], factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["G" /* map */])(function (factorUuid) {
			var element = findElement(factorUuid);
			return {
				name: element.name,
				uuid: element.uuid,
				urlImage: element.urlImage
			};
		}))(restCombinations), factor);
		restCombinations = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["V" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["w" /* has */])(factor.uuid), restCombinations);
		return newFactor;
	}, selectedFactors);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_toolConfigurartion__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_presents__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_levelType__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_answer__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_icons__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_job_evaluation_store_index__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getters__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mutations__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_helper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__persist__ = __webpack_require__(765);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	modules: {
		answer: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_6__store_modules_answer__["a" /* default */]),
		icon: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_7__store_modules_icons__["a" /* default */]),
		levelType: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_5__store_modules_levelType__["a" /* default */]),
		presentsConfiguration: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_4__store_modules_presents__["a" /* default */]),
		tool: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_3__store_modules_toolConfigurartion__["a" /* default */]),
		jobEvaluation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ namespaced: true }, __WEBPACK_IMPORTED_MODULE_8__modules_job_evaluation_store_index__["a" /* default */])
	},
	state: {
		appConfig: {
			isLoading: false,
			snackbar: {
				text: '',
				isVisible: false,
				color: 'primary'
			}
		},
		sideBarRoutes: {},
		pollData: {
			progress: 0
		},
		token: __WEBPACK_IMPORTED_MODULE_12__shared_helper__["a" /* default */].getLocalToken(),
		user: {
			email: '',
			logo: 'praktiko-logo.svg',
			profileImage: '',
			username: '',
			isEployee: false
		}
	},
	actions: __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_10__getters__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_11__mutations__["a" /* default */],
	plugins: [__WEBPACK_IMPORTED_MODULE_13__persist__["a" /* default */].plugin]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_MainLoader__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__ = __webpack_require__(775);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function indeterminate() {
	return this.$store.getters.indeterminate;
}

function snackbar() {
	return this.$store.getters.snackbar;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	components: { MainLoader: __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_ui_MainLoader__["a" /* default */] },
	computed: {
		indeterminate: indeterminate,
		snackbar: snackbar
	},
	mounted: function mounted() {
		// injecting css helpers for ui
		Object(__WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__["a" /* injectCssVariables */])();
		Object(__WEBPACK_IMPORTED_MODULE_1__utils_dynamic_css__["b" /* injectTextColors */])();
	}
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_app_bus__ = __webpack_require__(263);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'MainLoader',
	data: function data() {
		return {
			message: '',
			showLoader: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__bus_app_bus__["a" /* default */].$on('app-event-loader-toggle-view', function (_ref) {
			var show = _ref.show,
			    message = _ref.message;

			_this.showLoader = show;
			_this.message = message;
		});
	}
});

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeDrawer() {
	this.$emit('close-modal', false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-sidebar',
	methods: {
		closeDrawer: closeDrawer
	},
	model: {
		prop: 'value',
		event: 'close-modal'
	},
	props: {
		title: {
			type: String,
			required: true
		},
		value: {
			type: Boolean,
			required: true
		},
		width: {
			type: Number,
			default: 600
		},
		codeAction: {
			type: String,
			required: false
		},
		imgSrc: {
			type: String
		},
		headerColor: {
			type: String,
			default: 'white'
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(54);





var loadTools = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('tools');

					case 2:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.tools = response;
						setLocalData('tools', this.tools);

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadTools() {
		return _ref.apply(this, arguments);
	};
}();

var logout = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return this.$httpAcl.post('logout');

					case 3:
						window.localStorage.clear();
						this.showNotification('Se ha cerrado la sesión');
						this.goTo('login');
						_context2.next = 11;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](0);

						if (_context2.t0.status === 500) {
							this.showGenericError();
						}

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 8]]);
	}));

	return function logout() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].getLocalData,
    setLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData;


function created() {
	this.loadTools();
	this.getBreadCrumbs();
}

function getBreadCrumbs() {
	var _this = this;

	var matched = this.$route.matched;

	var _matched = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default()(matched),
	    rest = _matched.slice(1);

	this.breadCrumbs = rest.filter(function (r) {
		return !_this.sideBarRoutes[r.name];
	});
}

function routeHandler() {
	this.getBreadCrumbs();
}

function routeParams(_ref4) {
	var toolId = _ref4.toolId;

	var toolIdValue = Number(this.toolId) || Number(toolId);
	var routeTool = this.tools.find(function (t) {
		return t.id === toolIdValue;
	});
	this.secondRoute = routeTool ? routeTool.name : '';
	setLocalData('toolSelected', this.secondRoute);
}

function mounted() {
	this.secondRoute = getLocalData('toolSelected');
}

function data() {
	return {
		breadCrumbs: [],
		secondRoute: '',
		tools: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])({
		sideBarRoutes: function sideBarRoutes(state) {
			return state.sideBarRoutes;
		}
	})),
	created: created,
	data: data,
	methods: {
		getBreadCrumbs: getBreadCrumbs,
		loadTools: loadTools,
		logout: logout,
		routeHandler: routeHandler
	},
	mounted: mounted,
	props: {
		isVisible: {
			type: Boolean,
			default: false
		},
		logoUrl: String,
		title: String,
		toolId: [Number, String]
	},
	watch: {
		'$route.fullPath': routeHandler,
		'$route.params': routeParams
	}
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(111);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var params, headers, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$httpAcl.get('sidebar/' + 'praktiko-admin', { headers: headers, params: params });

					case 5:
						response = _context.sent;

						this.items = response.data.data.map(function (item) {
							_this.setRouteManifest(item);
							var newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
							if (item.resource.data.length === 0) {
								if (item.uri === _this.$route.path) {
									newItem.active = true;
								}
							} else {
								item.resource.data.forEach(function (src) {
									if (src.uri === _this.$route.path || '/' + src.uri === _this.$route.path) {
										newItem.active = true;
									}
								});
								item.resource.data.sort(function (a, b) {
									return a.position - b.position;
								});
							}
							return newItem;
						}).sort(function (a, b) {
							return a.position - b.position;
						});
						__WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].setLocalData('sidebar', this.items);
						this.$emit('active-route', this.items);
						this.$store.dispatch('setSideBarRoutes', this.routeObject);
						_context.next = 15;
						break;

					case 12:
						_context.prev = 12;
						_context.t0 = _context['catch'](2);

						this.$store.showSnackBar({
							color: 'error',
							text: 'Error interno, recargue la página e intente de nuevo'
						});

					case 15:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 12]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function data() {
	return {
		company: {
			logoOpen: 'https://quipu-static.s3.amazonaws.com/THEEND01_image/THEEND01_20147852360/logo-praktiko76.png',
			logoClose: 'https://quipu-static.s3.amazonaws.com/THEEND01_image/THEEND01_20147852360/group-42-copy-235.jpg'
		},
		drawer: true,
		items: [],
		mini: false,
		routeObject: {},
		user: {
			position: 'Gerente General'
		}
	};
}

function setRouteManifest(route) {
	var self = this;
	route.resource.data.forEach(function (r) {
		var uri = r.uri;

		self.routeObject[uri] = uri;
	});
}

function toggle() {
	this.mini = this.toggle;
}

function mini(value) {
	this.$emit('toggle-sidebar', value);
}

function goToUser() {
	this.goTo('profile');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-sidebar',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['fullName']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({
		avatar: function avatar(state) {
			return state.user.urlImage;
		}
	})),
	created: created,
	data: data,
	methods: {
		loadData: loadData,
		goToUser: goToUser,
		setRouteManifest: setRouteManifest
	},
	props: {
		toggle: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		toggle: toggle,
		mini: mini
	}
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-login'
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_sidebar__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_subheader__ = __webpack_require__(997);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function changeToggle(value) {
	this.isVisible = value;
}

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	var _this = this;

	this.routes = routes;
	var module = this.routes.find(function (mod) {
		return mod.name === _this.$route.meta.title;
	}) || {};
	this.logoUrl = module.pathIcon;
}

function notifications() {
	var allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach(function (productNot) {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach(function (saleNot) {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function $route(value) {
	var module = this.routes.find(function (mod) {
		return mod.name === value.meta.title;
	}) || {};
	this.logoUrl = module.pathIcon || this.$route.meta.logo;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468
		},
		isVisible: false,
		loading: false,
		logoUrl: '',
		routes: []
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-admin',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["a" /* default */],
		appHeader: __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__["a" /* default */],
		appSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_sidebar__["a" /* default */],
		appSubheader: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_subheader__["a" /* default */]
	},
	computed: {
		notifications: notifications,
		quantityNotifications: quantityNotifications,
		showIndeterminate: showIndeterminate
	},
	data: data,
	methods: {
		closeNotificationsModal: closeNotificationsModal,
		getRoutes: getRoutes,
		openNotificationsModal: openNotificationsModal,
		toggleSidebar: toggleSidebar,
		changeToggle: changeToggle
	},
	watch: {
		$route: $route
	}
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

function created() {
	window.addEventListener('resize', this.toolbarHeight);
	this.toolbarHeight();
}

function destroyed() {
	window.removeEventListener('resize', this.toolbarHeight);
}

function toolbarHeight() {
	var windowWidth = window.innerWidth;
	if (windowWidth >= 768) {
		this.heightToolbar = 40;
	} else {
		this.heightToolbar = 80;
	}
}

function data() {
	return {
		heightToolbar: 40
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-subheader',
	created: created,
	data: data,
	destroyed: destroyed,
	methods: {
		toolbarHeight: toolbarHeight
	}
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'general-filter'
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function splitDate(date) {
	return date.split('/');
}

function formatDate(date) {
	if (!date) {
		return null;
	}

	var _splitDate = splitDate(date),
	    _splitDate2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_splitDate, 3),
	    day = _splitDate2[0],
	    month = _splitDate2[1],
	    year = _splitDate2[2];

	return year + '-' + month + '-' + day;
}

function onChange($event, eventName) {
	var value = formatDate($event);
	if (value) {
		this.$emit(eventName, value);
	} else {
		this.$emit(eventName, null);
	}
}

function onInput($event) {
	this.$emit('input', $event);
	var dateValues = splitDate($event);
	if (dateValues && dateValues.length === 3) {
		this.$emit('format-date', __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(dateValues[2], dateValues[1] - 1, dateValues[0]), this.format));
	} else if (dateValues && dateValues.length < 3) {
		this.$emit('format-date', null);
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-date-mask',
	inheritAttrs: false,
	model: {
		prop: 'picker',
		event: 'input'
	},
	props: {
		format: {
			default: 'YYYY-MM-DD',
			type: String
		},
		label: {
			default: '',
			type: String
		},
		mask: {
			default: '##/##/####',
			type: String
		},
		picker: {
			default: null
		}
	},
	methods: {
		onChange: onChange,
		onInput: onInput
	}
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_column_item__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_helper__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ADD_REQUEST_EVENT = 'on-add-event';
var LOCAL_SEARCH_EVENT = 'on-local-search';
var SEARCH_EVENT = 'on-search-event';
var ON_DRAG_EVENT = 'on-drag-event';
var ON_DRAG_ENTER = 'on-drag-enter';
var ON_DRAG_LEAVE = 'on-drag-leave';
var ON_DROP_EVENT = 'on-drop-event';
var ON_PAGE_EVENT = 'on-page';
var ROW_IS_SELECTED = 'row-is-selected';
var ROW_ON_CLICK = 'row-on-click';
var SELECTED_ALL_EVENT = 'on-selected-all';
var TABLE_OPTION_EVENT = 'table-option-event';

var components = {
	TableColumnItem: __WEBPACK_IMPORTED_MODULE_1__table_column_item__["a" /* default */]
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function pagination(pageNumber, totalRecords) {
	var current = pageNumber;
	var last = totalRecords;
	var delta = 2;
	var left = current - delta;
	var right = current + delta + 1;
	var range = [];
	var rangeWithDots = [];
	var l = null;

	for (var i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _i = _step.value;

			if (l) {
				if (_i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (_i - l !== 1) {
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(_i);
			l = _i;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	var columnsInLocalStorage = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::columns');
	if (columnsInLocalStorage) {
		this.columns.forEach(function (col) {
			var newCol = col;
			var colToChange = columnsInLocalStorage.find(function (c) {
				return c.id === newCol.id;
			});
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		var searchFromLocalStorage = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::search');
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}

function toggleColumns() {
	var _this = this;

	this.selectedColumns = this.columns.filter(function (c) {
		return !c.checked;
	});
	this.columns.forEach(function (col) {
		var newCol = col;
		var colToChange = _this.selectedColumns.find(function (c) {
			return c.id === newCol.id;
		});
		newCol.visible = typeof colToChange === 'undefined';
	});
	__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::columns', this.selectedColumns);
	this.showMenu = false;
}

function selectedAll(_ref) {
	var target = _ref.target;

	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	if (this.selectable) {
		this.$set(row, 'isSelected', !row.isSelected);
		this.$emit(ROW_IS_SELECTED, row);
	} else {
		this.$emit(ROW_ON_CLICK, row);
	}
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		var dataToLocalSearch = this.search.toLowerCase();
		__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		__WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function selectPage(page) {
	var newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	var action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: '/static/img/actions-list/cancel.svg',
		open: true,
		title: 'FILTRAR POR',
		width: 229
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'left';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	return this.columns.filter(function (c) {
		return c.visible;
	}).length + 1;
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table',
	components: components,
	computed: {
		pages: pages,
		totalVisibleColumns: totalVisibleColumns
	},
	data: data,
	methods: {
		addOption: addOption,
		onDrag: onDrag,
		onDragEnter: onDragEnter,
		onDragLeave: onDragLeave,
		onDrop: onDrop,
		optionsDirection: optionsDirection,
		rowIsSelected: rowIsSelected,
		searchRows: searchRows,
		selectedAll: selectedAll,
		selectPage: selectPage,
		selectLastPage: selectLastPage,
		tableOption: tableOption,
		toggleColumns: toggleColumns
	},
	mounted: mounted,
	props: {
		iconArea: {
			default: false,
			type: Boolean
		},
		iconEmployee: {
			default: false,
			type: Boolean
		},
		addButton: {
			default: false,
			type: Boolean
		},
		checkAll: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 1
		},
		dispatchDetail: {
			default: false,
			type: Boolean
		},
		filterColumns: {
			default: true,
			type: Boolean
		},
		includeFilter: {
			type: Boolean,
			default: false
		},
		inputSearch: {
			default: true,
			type: Boolean
		},
		localSearch: {
			type: Boolean,
			default: false
		},
		localStorage: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Array,
			required: true
		},
		selectable: {
			type: Boolean,
			default: false
		},
		lastPage: {
			type: Number,
			default: 0
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		mainList: {
			type: Boolean,
			default: true
		},
		cleanSearch: {
			default: false,
			type: Boolean
		},
		title: String,
		iconExcel: {
			default: false,
			type: Boolean
		},
		disabledAssign: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		cleanSearch: cleanSearch
	}
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function data() {
	return {
		showInput: false
	};
}

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

function toggleInput(column) {
	var _this = this;

	this.$set(column, 'showInput', !column.showInput);
	if (column.showInput) {
		this.$nextTick(function () {
			var columnInput = _this.$refs['colheader' + column.id];
			if (columnInput) {
				columnInput.focus();
			}
		});
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'table-column-item',
	data: data,
	props: {
		column: {
			type: Object,
			required: true
		},
		onCloumnSortable: {
			type: Function
		}
	},
	methods: {
		onColumnSortable: onColumnSortable,
		toggleInput: toggleInput
	}
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		isListAll: isListAll
	},
	props: {
		color: {
			type: String,
			default: 'success'
		},
		icon: String,
		img: String,
		size: [Number, String],
		text: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function columnsToExport() {
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var newColumns = columnsSelected.map(function (col) {
		var newCol = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	var tableDataToExport = [];
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var columnsValues = columnsSelected.map(function (colVal) {
		var newColVal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(function (dataExport) {
			var newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, dataExport);
			var keysData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataExport);
			keysData.forEach(function (keyData) {
				if (columnsValues.every(function (keyCol) {
					return keyCol !== keyData;
				})) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header-page',
	computed: {
		columnsToExport: columnsToExport,
		dataToExport: dataToExport
	},
	methods: {
		downloadDispatch: downloadDispatch,
		downloadDocument: downloadDocument,
		print: print
	},
	props: {
		columns: {
			type: Array
		},
		exportToPdf: {
			default: false,
			type: Boolean
		},
		name: {
			type: String
		},
		rows: {
			type: Array
		},
		showClean: {
			default: true,
			type: Boolean
		},
		showExcel: {
			default: true,
			type: Boolean
		},
		title: {
			type: String,
			required: true
		},
		toShow: {
			default: false,
			type: Boolean
		},
		quotation: {
			default: false,
			type: Boolean
		},
		sale: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-sidebar'
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'modal-sidebar-button',
	methods: {
		cancelModal: cancelModal,
		setInfo: setInfo
	},
	props: {
		isLoading: {
			default: false,
			type: Boolean
		},
		hidden: {
			type: Boolean,
			default: false
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false
		},
		successColor: {
			default: 'success',
			type: String
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String
		},
		successText: {
			default: 'Aceptar',
			type: String
		},
		cancelText: {
			default: 'Cancelar',
			type: String
		}
	}
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8445c8b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__ = __webpack_require__(972);
function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8445c8b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8445c8b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7bf00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(987);
function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b7bf00e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7bf00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea8cdf78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea8cdf78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea8cdf78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commandMap; });
/* unused harmony export commandMapInverted */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseHierarchyAssignation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseAssignationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseOrganizationChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_helpers_helpers__ = __webpack_require__(364);





var commandMap = {
	highCommand: 'HIGH',
	mediumCommand: 'MIDDLE',
	lowCommand: 'UNDER'
};

var commandMapInverted = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["A" /* invertObj */])(commandMap);
var concatAll = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["U" /* reduce */])(__WEBPACK_IMPORTED_MODULE_2_ramda__["m" /* concat */], []);
var getCurrentToolCode = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['mainData', 'code']);
var getCommandByTypeVerb = function getCommandByTypeVerb(job) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('typeVerb', job), commandMapInverted);
};
var matchWithLocalVerbs = function matchWithLocalVerbs(state, job) {
	return function (verbCode) {
		return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* propEq */])('code', verbCode), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'guidelineModel', 'verbsSelection', getCommandByTypeVerb(job), 'details']), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["M" /* pick */])(['id', 'name', 'code'])))(state));
	};
};
var parseVerbs = function parseVerbs(state) {
	return function (job) {
		return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["S" /* propOr */])({}, getCommandByTypeVerb(job)), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* reject */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["p" /* equals */])(false)), __WEBPACK_IMPORTED_MODULE_2_ramda__["D" /* keys */], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(matchWithLocalVerbs(state, job)), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["V" /* reject */])(__WEBPACK_IMPORTED_MODULE_2_ramda__["C" /* isNil */]))(job);
	};
};

var parseHierarchyAssignation = function parseHierarchyAssignation(assignations) {
	var overrideVerbStructure = function overrideVerbStructure(usedCommand, originalJob) {
		return function (parsedJob) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["j" /* assoc */])(usedCommand, Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('verbsCode'), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["O" /* pluck */])('code'), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(function (k) {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, k, true);
			}), __WEBPACK_IMPORTED_MODULE_2_ramda__["H" /* mergeAll */])(originalJob), parsedJob);
		};
	};
	var parseJobs = function parseJobs(originalJob) {
		var usedCommand = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('typeVerb', originalJob), commandMapInverted);
		return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
			id: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('id'),
			name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('name'),
			role: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('roleId'),
			title: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('titulationId'),
			typeVerb: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('typeVerb'),
			experience: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('expirienceTimeId'),
			fatherId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('fatherId'),
			fatherName: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('fatherName'),
			highCommand: function highCommand() {
				return {};
			},
			mediumCommand: function mediumCommand() {
				return {};
			},
			lowCommand: function lowCommand() {
				return {};
			}
		}), overrideVerbStructure(usedCommand, originalJob), function (j) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["j" /* assoc */])('completed', Object(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_helpers_helpers__["b" /* verifyJobIsCompleted */])(j), j);
		})(originalJob);
	};
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
		id: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('id'),
		job: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["K" /* path */])(['question', 'name']),
		hasError: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('flagFix'),
		jobPositions: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('details'), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(parseJobs))
	}), assignations || []);
};

var toolCommonConfig = {
	name: 'Valoración de puestos',
	languages: {
		SPA: { name: 'Nombre de la encuesta 001' },
		ENG: { name: 'Poll name 001' },
		FRA: { name: 'Nom du sondage 001' }
	},
	stageStatus: 1,
	stageDetailStatus: 1
};

var parseAssignationRequest = function parseAssignationRequest(state) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		toolCode: getCurrentToolCode(state)
	}, toolCommonConfig, {
		jobs: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'guidelineModel', 'userForm', 'jobList']), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
			// id: job => prop('id', job) || null,
			father: function father(job) {
				return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('father', job) || null;
			},
			name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('name'),
			roleId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('role'),
			titulationId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('title'),
			expirienceTimeId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('experience'),
			typeVerb: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('typeVerb'),
			verbsCode: parseVerbs(state)
		})))(state)
	});
};

var parseOrganizationChart = function parseOrganizationChart(state) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		toolCode: getCurrentToolCode(state)
	}, toolCommonConfig, {
		stageStatus: 1,
		stageDetailStatus: 2,
		jobs: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'guidelineModel', 'hierarchyAssignation']), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["O" /* pluck */])('jobPositions'), concatAll, Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
			father: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('fatherName'),
			name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('name'),
			roleId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('role'),
			titulationId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('title'),
			expirienceTimeId: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('experience'),
			typeVerb: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('typeVerb'),
			verbsCode: parseVerbs(state)
		})))(state)
	});
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPGM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNewDegree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPGm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assocRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseRequestValuation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(31);




var mapIndexed = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* addIndex */])(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */]);
var BASE_PG = 1000;

var getPGM = function getPGM(factor, combinations) {
	var totalSum = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["h" /* factorWeighingSum */])(factor, combinations);
	var totalWeighing = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["o" /* totalSumWeighings */])(combinations);
	var percentage = Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["l" /* getPercentageByValue */])(totalSum, totalWeighing);
	return Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["m" /* getPercentageValue */])(parseFloat(percentage), BASE_PG);
};

var getNewDegree = function getNewDegree(data) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		code: null
	}, data, {
		uuid: Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["n" /* getSlugify */])(data.name)
	});
};

var toFixed = function toFixed(value) {
	return Math.round(value) === value ? value : value.toFixed(2);
};

var getPGm = function getPGm(pgMax, degrees) {
	return toFixed(pgMax / (Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["F" /* length */])(degrees) || 1));
};

var assocRate = function assocRate(pgMax, selectedDegrees, degree) {
	var rate = 0;
	if (degree.selected) {
		var indexFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* propEq */])('uuid', degree.uuid), selectedDegrees);
		var progressionValue = pgMax / Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["F" /* length */])(selectedDegrees);
		rate = toFixed((indexFound + 1) * progressionValue);
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, degree, {
		rate: rate
	});
};

var getFactorsWeight = function getFactorsWeight(selectedFactors, combinations, factorDegrees) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(function (factor) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["M" /* pick */])(['id', 'name'], factor), {
			criterionId: null,
			criterionName: null,
			totalWeight: Object(__WEBPACK_IMPORTED_MODULE_1__modules_job_evaluation_utils_valuation_model_factors__["h" /* factorWeighingSum */])(factor, combinations),
			totalGrade: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])(factor.uuid), __WEBPACK_IMPORTED_MODULE_2_ramda__["F" /* length */])(factorDegrees),
			grades: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])(factor.uuid), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* applySpec */])({
				code: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('uuid'),
				name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('name'),
				flagActive: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('selected'), function (value) {
					return value ? 1 : 0;
				}),
				rate: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('rate')
			})))(factorDegrees),
			relatedFactorWeights: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["q" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["w" /* has */])(factor.uuid)), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["n" /* dissoc */])(factor.uuid)), mapIndexed(function (relatedFactor) {
				var relatedFactorUuid = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["x" /* head */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["D" /* keys */])(relatedFactor));
				var factorFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* propEq */])('uuid', relatedFactorUuid), selectedFactors);
				return {
					id: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('id', factorFound),
					name: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])('name', factorFound),
					weight: Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["Q" /* prop */])(relatedFactorUuid, relatedFactor),
					criterionId: 1
				};
			}))(combinations)
		});
	}, selectedFactors);
};

var parseRequestValuation = function parseRequestValuation(state) {
	var selectedFactors = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'valuationModel', 'selectedFactors'], state);
	var combinations = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'valuationModel', 'weighing', 'combinations'], state);
	var factorDegrees = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["L" /* pathOr */])([], ['supplies', 'valuationModel', 'degree', 'factorDegrees'], state);
	return {
		name: 'Nombre de la encuesta 001',
		toolCode: 'JEV',
		languages: {
			SPA: { name: 'Nombre de la encuesta 001' },
			ENG: { name: 'Poll name 001' },
			FRA: { name: 'Nom du sondage 001' }
		},
		stageStatus: 1,
		stageDetailStatus: 3,
		factorsWeight: getFactorsWeight(selectedFactors, combinations, factorDegrees)
	};
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return verifyJobIsCompleted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(31);


var hasValidValue = function hasValidValue(value) {
	return !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["C" /* isNil */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["B" /* isEmpty */])(value);
};

var generateJob = function generateJob(jobName) {
	return {
		name: jobName,
		highCommand: {},
		mediumCommand: {},
		lowCommand: {},
		role: {},
		title: {},
		experience: {},
		completed: false,
		typeVerb: null
	};
};

var verifyJobIsCompleted = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["e" /* allPass */])([Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["N" /* pipe */])(function (job) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["q" /* filter */])(function (levelKey) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["g" /* any */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["p" /* equals */])(true), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_2" /* values */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["Q" /* prop */])(levelKey, job)));
	}, ['highCommand', 'mediumCommand', 'lowCommand']);
}, __WEBPACK_IMPORTED_MODULE_0_ramda__["x" /* head */], __WEBPACK_IMPORTED_MODULE_0_ramda__["C" /* isNil */], __WEBPACK_IMPORTED_MODULE_0_ramda__["J" /* not */]), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["Q" /* prop */])('role'), hasValidValue), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["Q" /* prop */])('title'), hasValidValue), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["Q" /* prop */])('experience'), hasValidValue)]);

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_drag_drop__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_shortkey__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_org_tree__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_org_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_org_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_org_tree_dist_style_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_org_tree_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_org_tree_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_charts_css_dist_charts_min_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_charts_css_dist_charts_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_charts_css_dist_charts_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuetify__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__http_index__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_global__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__filters_global__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__global_components__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_helper__ = __webpack_require__(54);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var route, surveyId, token, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						route = window.location.pathname;
						surveyId = Number(route.split('/')[2]);

						__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appColors = JSON.parse('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success":   "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent":   "#005CAF","error": "#f42b17","warning": "#FFB74C"}');
						__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$userInfo = __WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].getLocalData('praktiko-user');
						__WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].setLocalData('surveyId', surveyId);
						this.$http.interceptors.request.use(this.httpRequestInterceptor);
						this.$http.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpAcl.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpPraktiko.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpPraktiko.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpUpLoad.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpUpLoad.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpJobEvaluation.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpJobEvaluation.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						token = __WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].getLocalToken();

						if (!token) {
							_context.next = 25;
							break;
						}

						_context.next = 19;
						return this.$httpPraktiko.get('employee/current');

					case 19:
						_ref2 = _context.sent;
						response = _ref2.data;

						__WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].setLocalData('praktiko-user', response);
						__WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].setLocalData('acl-code', response.aclCode);
						this.$store.dispatch('setUser', response);
						__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$userInfo = __WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].getLocalData('praktiko-user');

					case 25:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

/* eslint-disable no-new */























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue2_org_tree___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_drag_drop___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'praktiko.netlify.com'
});

var userInfo = __WEBPACK_IMPORTED_MODULE_21__shared_helper__["a" /* default */].getLocalData('praktiko-user');
var router = Object(__WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_19__filters_global__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_14__vuetify__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_16__axios__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$imageUrl = '//s3.amazonaws.com/apprunn-acl/icons';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$userInfo = userInfo;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_18__mixins_global__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
	created: created,
	el: '#app',
	methods: {
		httpRequestInterceptor: __WEBPACK_IMPORTED_MODULE_15__http_index__["a" /* httpRequestInterceptor */],
		httpResponseInterceptor: __WEBPACK_IMPORTED_MODULE_15__http_index__["b" /* httpResponseInterceptor */],
		httpResponseSuccessInterceptor: __WEBPACK_IMPORTED_MODULE_15__http_index__["c" /* httpResponseSuccessInterceptor */]
	},
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_13__App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */]
});

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(47);




/* eslint-disable no-param-reassign */

var toolConfigurationModule = {
	actions: {
		createNewTool: function createNewTool(_ref, body) {
			var _this = this;

			var dispatch = _ref.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post('tools', body);

							case 2:
								_context.next = 4;
								return dispatch('loadTools');

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		createLevel: function createLevel(_ref3, _ref2) {
			var _this2 = this;

			var dispatch = _ref3.dispatch;

			var toolCode = _ref2.toolCode,
			    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['toolCode']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								url = 'hierarchies/' + toolCode;
								_context2.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post(url, rest);

							case 3:
								dispatch('toolDetail', toolCode);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		delete: function _delete(_ref4, id) {
			var _this3 = this;

			var dispatch = _ref4.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].delete('tools/' + id);

							case 2:
								_context3.next = 4;
								return dispatch('loadTools');

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		editLevel: function editLevel(_ref6, _ref5) {
			var _this4 = this;

			var dispatch = _ref6.dispatch;

			var toolCode = _ref5.toolCode,
			    id = _ref5.id,
			    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['toolCode', 'id']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								url = 'hierarchies/' + id;
								_context4.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].patch(url, rest);

							case 3:
								dispatch('toolDetail', toolCode);

							case 4:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		editTool: function editTool(_ref8, _ref7) {
			var _this5 = this;

			var dispatch = _ref8.dispatch;

			var id = _ref7.id,
			    body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref7, ['id']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								url = 'tools/' + id;
								_context5.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].patch(url, body);

							case 3:
								_context5.next = 5;
								return dispatch('loadTools');

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		loadTool: function loadTool(_ref9, code) {
			var _this6 = this;

			var commit = _ref9.commit,
			    dispatch = _ref9.dispatch;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var url, _ref10, response, answerId, description, id, images, name, templateId, urlImage, videos, toolData;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								url = 'tools/' + code;
								_context6.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref10 = _context6.sent;
								response = _ref10.data;
								answerId = response.answerId, description = response.description, id = response.id, images = response.images, name = response.name, templateId = response.templateId, urlImage = response.urlImage.web, videos = response.videos;
								toolData = {
									code: code,
									description: description,
									id: id,
									image: '',
									images: images,
									name: name,
									templateId: templateId,
									urlImage: urlImage,
									videos: videos,
									videoLink: ''
								};

								commit('SET_EDITING_TOOL_ID', toolData.id);
								commit('SET_EDITING_TOOL', toolData);
								commit('NEW_TOOL_TEMPLATE_ID', templateId);
								dispatch('answer/selectedTypeAnswer', answerId, { root: true });
								dispatch('icon/callingIconsAndSelectingIt', urlImage, { root: true });

							case 12:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		loadTools: function loadTools(_ref11) {
			var _this7 = this;

			var commit = _ref11.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var _ref12, response;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get('tools');

							case 2:
								_ref12 = _context7.sent;
								response = _ref12.data;

								commit('SET_TOOLS', response);

							case 5:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		loadToolType: function loadToolType(_ref13) {
			var _this8 = this;

			var commit = _ref13.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var _ref14, res;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_context8.next = 2;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get('templates');

							case 2:
								_ref14 = _context8.sent;
								res = _ref14.data;

								commit('SET_TOOLS_TEMPLATES', res);

							case 5:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this8);
			}))();
		},
		selectTemplate: function selectTemplate(_ref15, template) {
			var commit = _ref15.commit;

			commit('NEW_TOOL_TEMPLATE_ID', template.id);
		},
		setFlagEditTool: function setFlagEditTool(_ref16, id) {
			var commit = _ref16.commit;

			commit('SET_EDITING_TOOL_ID', id);
		},
		setNewToolData: function setNewToolData(_ref17, newTool) {
			var commit = _ref17.commit;

			commit('NEW_TOOL_TEMPLATE_ID', newTool.templateId);
			commit('NEW_TOOL_DESCRIPTION', newTool.description);
			commit('NEW_TOOL_NAME', newTool.name);
			commit('NEW_TOOL_CODE', newTool.code);
		},
		toolDetail: function toolDetail(_ref18, toolCode) {
			var _this9 = this;

			var commit = _ref18.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
				var url, _ref19, res;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								url = 'hierarchies/' + toolCode;
								_context9.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref19 = _context9.sent;
								res = _ref19.data;

								commit('SET_TOOLS_DETAIL', res);

							case 6:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this9);
			}))();
		}
	},
	state: {
		details: null,
		editing: {
			id: 0,
			toolData: {}
		},
		templateId: 0,
		templates: [],
		newToolCode: '',
		newToolDescription: '',
		newToolName: '',
		tools: [],
		urlImage: null
	},
	mutations: {
		NEW_TOOL_TEMPLATE_ID: function NEW_TOOL_TEMPLATE_ID(state, id) {
			state.templateId = id;
		},
		NEW_TOOL_CODE: function NEW_TOOL_CODE(state, code) {
			state.newToolCode = code;
		},
		NEW_TOOL_DESCRIPTION: function NEW_TOOL_DESCRIPTION(state, description) {
			state.newToolDescription = description;
		},
		NEW_TOOL_NAME: function NEW_TOOL_NAME(state, name) {
			state.newToolName = name;
		},
		SET_EDITING_TOOL: function SET_EDITING_TOOL(state, data) {
			state.editing.toolData = data;
		},
		SET_EDITING_TOOL_ID: function SET_EDITING_TOOL_ID(state, id) {
			state.editing.id = id;
		},
		SET_TOOLS: function SET_TOOLS(state, tools) {
			state.tools = tools;
		},
		SET_TOOLS_DETAIL: function SET_TOOLS_DETAIL(state, toolsDetail) {
			state.details = toolsDetail;
		},
		SET_TOOLS_TEMPLATES: function SET_TOOLS_TEMPLATES(state, templates) {
			state.templates = templates;
		}
	},
	getters: {}
};

/* harmony default export */ __webpack_exports__["a"] = (toolConfigurationModule);

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axios__ = __webpack_require__(47);







/* eslint-disable no-param-reassign */

var presentsConfigurationModule = {
	actions: {
		clearPresentsByEmployee: function clearPresentsByEmployee(_ref) {
			var commit = _ref.commit;

			commit('SET_GOTIT_PRESENTS', []);
		},
		createPresent: function createPresent(_ref2, body) {
			var _this = this;

			var dispatch = _ref2.dispatch;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].post('awards', body);

							case 2:
								dispatch('resetingPresentData');

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		deletePresent: function deletePresent(_ref3, id) {
			var _this2 = this;

			var dispatch = _ref3.dispatch;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].delete('awards/' + id);

							case 2:
								dispatch('loadAllPresents');

							case 3:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		loadAllPresents: function loadAllPresents(_ref4) {
			var _this3 = this;

			var commit = _ref4.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _ref5, response;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('awards');

							case 2:
								_ref5 = _context3.sent;
								response = _ref5.data;

								commit('SET_PRESENTS', response);

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		loadPresentsByEmployee: function loadPresentsByEmployee(_ref6, employeeId) {
			var _this4 = this;

			var commit = _ref6.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var requests, _ref7, _ref8, avaliablePresents, myPresents;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								requests = [__WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('/awards/employee/' + employeeId), __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('/employee/' + employeeId + '/award')];
								_context4.next = 3;
								return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requests);

							case 3:
								_ref7 = _context4.sent;
								_ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
								avaliablePresents = _ref8[0].data;
								myPresents = _ref8[1].data;

								commit('SET_PENDING_PRESENTS', avaliablePresents);
								commit('SET_GOTIT_PRESENTS', myPresents.awards);

							case 9:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		loadWonPresentsByEmployee: function loadWonPresentsByEmployee(_ref9) {
			var _this5 = this;

			var commit = _ref9.commit;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref10, response;

				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].get('employee-role/award');

							case 2:
								_ref10 = _context5.sent;
								response = _ref10.data;

								commit('SET_GOTIT_PRESENTS', response);

							case 5:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		redeemPresent: function redeemPresent(_ref11, _ref12) {
			var _this6 = this;

			var dispatch = _ref11.dispatch;
			var presentId = _ref12.presentId,
			    employeeId = _ref12.employeeId;
			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var url, body;
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								url = 'employee-award';
								body = { awardId: presentId, employeeId: employeeId };
								_context6.next = 4;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].post(url, body);

							case 4:
								dispatch('loadPresentsByEmployee', employeeId);

							case 5:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		resetingPresentData: function resetingPresentData(_ref13) {
			var dispatch = _ref13.dispatch;

			dispatch('loadAllPresents');
			dispatch('setNewPresentData', null);
		},
		setEditingPresentId: function setEditingPresentId(_ref14, presentId) {
			var commit = _ref14.commit;

			commit('SET_EDITING_PRESENT_ID', presentId);
		},
		setNewPresentData: function setNewPresentData(_ref15, newPresentData) {
			var commit = _ref15.commit;

			commit('SET_NEW_PRESENT_DATA', newPresentData);
		},
		updatePresent: function updatePresent(_ref17, _ref16) {
			var _this7 = this;

			var dispatch = _ref17.dispatch;

			var id = _ref16.id,
			    rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref16, ['id']);

			return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
				return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return __WEBPACK_IMPORTED_MODULE_6__axios__["c" /* praktikoInstance */].patch('awards/' + id, rest);

							case 2:
								dispatch('resetingPresentData');
								dispatch('setEditingPresentId', 0);

							case 4:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))();
		},
		updatePresentAction: function updatePresentAction(_ref18, present) {
			var dispatch = _ref18.dispatch;

			if (present) {
				var name = present.name,
				    points = present.points,
				    id = present.id;

				dispatch('setNewPresentData', { name: name, points: points });
				dispatch('setEditingPresentId', id);
			} else {
				dispatch('setNewPresentData', null);
				dispatch('setEditingPresentId', 0);
			}
		}
	},
	state: {
		editingPresentId: 0,
		newPresentData: null,
		presents: [],
		presentsByEmployee: {
			pending: [],
			gotIt: []
		}
	},
	mutations: {
		SET_EDITING_PRESENT_ID: function SET_EDITING_PRESENT_ID(state, id) {
			state.editingPresentId = id;
		},
		SET_GOTIT_PRESENTS: function SET_GOTIT_PRESENTS(state, presents) {
			state.presentsByEmployee.gotIt = presents;
		},
		SET_NEW_PRESENT_DATA: function SET_NEW_PRESENT_DATA(state, newPresentData) {
			state.newPresentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newPresentData);
		},
		SET_PENDING_PRESENTS: function SET_PENDING_PRESENTS(state, presents) {
			state.presentsByEmployee.pending = presents;
		},
		SET_PRESENTS: function SET_PRESENTS(state, presents) {
			state.presents = presents;
		}
	},
	getters: {
		presentName: function presentName(state) {
			return state.newPresentData ? state.newPresentData.name : '';
		},
		presentPoints: function presentPoints(state) {
			return state.newPresentData ? state.newPresentData.points : 0;
		},
		flagEdit: function flagEdit(state) {
			return !!state.editingPresentId;
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (presentsConfigurationModule);

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(47);




/* eslint-disable no-param-reassign */

var levelTypeModule = {
	actions: {
		create: function create(_ref2, _ref) {
			var _this = this;

			var dispatch = _ref2.dispatch;

			var toolCode = _ref.toolCode,
			    rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['toolCode']);

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var url;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								url = 'tools-type';
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].post(url, rest);

							case 3:
								dispatch('load', toolCode);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		load: function load(_ref3, toolCode) {
			var _this2 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var url, _ref4, levels;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								url = 'tools-type/' + toolCode;
								_context2.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3__axios__["b" /* pollInstance */].get(url);

							case 3:
								_ref4 = _context2.sent;
								levels = _ref4.data;

								commit('SET_LEVELS_BY_TOOL', levels);

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	},
	getters: {
		levels: function levels(state) {
			return [].concat({ name: 'Nuevo tipo' }, state.list);
		}
	},
	mutations: {
		SET_LEVELS_BY_TOOL: function SET_LEVELS_BY_TOOL(state, levels) {
			state.list = levels;
		}
	},
	state: {
		list: []
	}
};

/* harmony default export */ __webpack_exports__["a"] = (levelTypeModule);

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(47);





/* eslint-disable no-param-reassign */

function answersConstructor(n, state) {
	var answer = state.answersDefinition;
	var arr = new Array(n);
	var len = arr.length;
	for (var i = 0; i < len; i += 1) {
		var currentAnswer = state.partial.answers[i];
		arr[i] = currentAnswer || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, answer);
	}
	return arr;
}

function formatingAnswers(answers) {
	return answers.map(function (a) {
		var name = a.name,
		    value = a.value;

		var b = {
			name: name,
			value: value,
			urlImage: { web: a.icon.urlImage }
		};
		return b;
	});
}

function formattingEditingAnswerData(answer) {
	return answer.map(function (a) {
		var name = a.name,
		    value = a.value,
		    web = a.urlImage.web;

		return { name: name, value: value, icon: { urlImage: web } };
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	actions: {
		createAnswer: function createAnswer(_ref) {
			var _this = this;

			var dispatch = _ref.dispatch,
			    state = _ref.state;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _state$partial, name, number, type, flagNoUse, answers, body;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_state$partial = state.partial, name = _state$partial.name, number = _state$partial.number, type = _state$partial.type, flagNoUse = _state$partial.flagNoUse, answers = _state$partial.answers;
								body = {
									name: name,
									quantityAnswer: number,
									typeAnswerId: type.id,
									mode: 1,
									apply: flagNoUse,
									details: formatingAnswers(answers)
								};
								_context.next = 4;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].post('answers', body);

							case 4:
								dispatch('loadAnswers');

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		editAnswer: function editAnswer(_ref2) {
			var _this2 = this;

			var dispatch = _ref2.dispatch,
			    state = _ref2.state,
			    commit = _ref2.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var id, partial, name, number, type, flagNoUse, answers, body;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								id = state.editingAnswerId, partial = state.partial;
								name = partial.name, number = partial.number, type = partial.type, flagNoUse = partial.flagNoUse, answers = partial.answers;
								body = {
									name: name,
									quantityAnswer: number,
									typeAnswerId: type,
									mode: 1,
									apply: flagNoUse,
									details: formatingAnswers(answers)
								};
								_context2.next = 5;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].patch('answers/' + id, body);

							case 5:
								dispatch('loadAnswers');
								commit('SET_EDITING_ANSWER_ID', 0);

							case 7:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		loadAnswersByType: function loadAnswersByType(_ref3) {
			var _this3 = this;

			var commit = _ref3.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var _ref4, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers');

							case 2:
								_ref4 = _context3.sent;
								res = _ref4.data;

								commit('SET_ANSWERS_BY_TYPE', res);

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		loadAnswers: function loadAnswers(_ref5) {
			var _this4 = this;

			var commit = _ref5.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var _ref6, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers');

							case 2:
								_ref6 = _context4.sent;
								res = _ref6.data;

								commit('SET_ANSWERS', res);

							case 5:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))();
		},
		loadEditingAnswerData: function loadEditingAnswerData(_ref7, id) {
			var _this5 = this;

			var dispatch = _ref7.dispatch,
			    commit = _ref7.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var _ref8, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers/' + id);

							case 2:
								_ref8 = _context5.sent;
								res = _ref8.data;

								commit('SET_EDITING_ANSWER_ID', id);
								dispatch('setAnswerData', res);

							case 6:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))();
		},
		deleteAnswer: function deleteAnswer(_ref9, _ref10) {
			var _this6 = this;

			var dispatch = _ref9.dispatch;
			var answerId = _ref10.answerId;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.next = 2;
								return __WEBPACK_IMPORTED_MODULE_4__axios__["b" /* pollInstance */].get('answers/' + answerId);

							case 2:
								dispatch('loadAnswers');

							case 3:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))();
		},
		setAnswerData: function setAnswerData(_ref11, res) {
			var commit = _ref11.commit;
			var name = res.name,
			    type = res.typeAnswerId,
			    answers = res.details,
			    number = res.quantityAnswer;

			var formattedAnswers = formattingEditingAnswerData(answers);
			commit('SET_BASIC_DATA', { answers: formattedAnswers, name: name, type: type, number: number });
		},
		selectedTypeAnswer: function selectedTypeAnswer(_ref12, id) {
			var commit = _ref12.commit;

			commit('SET_TYPE_ANSWER_SELECTED', id);
		},
		setBasicData: function setBasicData(_ref13, answerData) {
			var commit = _ref13.commit,
			    state = _ref13.state;

			var answer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, answerData);
			answer.type = answerData.type[0];
			answer.answers = answersConstructor(answer.number, state);
			commit('SET_BASIC_DATA', answer);
		},
		cleanBasicData: function cleanBasicData(_ref14) {
			var commit = _ref14.commit,
			    state = _ref14.state;

			var answer = {
				answers: [state.answersDefinition],
				name: '',
				number: 1,
				type: {}
			};
			commit('SET_BASIC_DATA', answer);
		},
		setFlagNoUse: function setFlagNoUse(_ref15, flag) {
			var commit = _ref15.commit;

			commit('SET_FLAG_NO_USE', flag);
		},
		updateAnswers: function updateAnswers(_ref16, _ref17) {
			var commit = _ref16.commit;
			var icon = _ref17.icon,
			    index = _ref17.index;

			commit('UPDATE_PARTIAL_ANSWERS', { icon: icon, index: index });
		}
	},
	getters: {
		invalidAnswer: function invalidAnswer(state) {
			var _state$partial2 = state.partial,
			    name = _state$partial2.name,
			    type = _state$partial2.type;

			return !(name && type);
		}
	},
	mutations: {
		SET_ANSWERS: function SET_ANSWERS(state, answersNumber) {
			state.answers.list = answersNumber;
		},
		SET_ANSWERS_BY_TYPE: function SET_ANSWERS_BY_TYPE(state, answers) {
			state.answers.answersByType = answers;
		},
		SET_BASIC_DATA: function SET_BASIC_DATA(state, data) {
			state.partial = data;
		},
		SET_EDITING_ANSWER_ID: function SET_EDITING_ANSWER_ID(state, id) {
			state.editingAnswerId = id;
		},
		SET_FLAG_NO_USE: function SET_FLAG_NO_USE(state, flag) {
			state.partial.flagNoUse = flag;
		},
		SET_TYPE_ANSWER_SELECTED: function SET_TYPE_ANSWER_SELECTED(state, id) {
			state.answers.typeAnswerSelectedId = id;
		},
		UPDATE_PARTIAL_ANSWERS: function UPDATE_PARTIAL_ANSWERS(state, _ref18) {
			var icon = _ref18.icon,
			    index = _ref18.index;

			__WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.partial.answers[index], 'icon', icon);
		}
	},
	state: {
		answers: {
			answersByType: [],
			list: [],
			listBy: [],
			typeAnswerSelectedId: 0
		},
		answersDefinition: { name: '', value: 0, icon: { urlImage: '' } },
		partial: {
			answers: [{ name: '', value: 0, icon: { urlImage: '' } }],
			flagNoUse: false,
			name: '',
			number: 1,
			type: null
		},
		editingAnswerId: null
	}
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(47);



/* eslint-disable no-param-reassign */

function searchIconByUrl(urlIcon, iconList) {
	return iconList.find(function (i) {
		return i.urlImage === urlIcon;
	});
}

var iconModule = {
	actions: {
		create: function create(_ref, body) {
			var _this = this;

			var dispatch = _ref.dispatch;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2__axios__["c" /* praktikoInstance */].post('icons', body);

							case 2:
								dispatch('load');

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		load: function load(_ref2) {
			var _this2 = this;

			var commit = _ref2.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var _ref3, res;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __WEBPACK_IMPORTED_MODULE_2__axios__["c" /* praktikoInstance */].get('icons');

							case 2:
								_ref3 = _context2.sent;
								res = _ref3.data;

								commit('SET_ICON_LIST', res);

							case 5:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		selectIconAction: function selectIconAction(_ref4, icon) {
			var commit = _ref4.commit;

			commit('SET_SELECTED_ICON', icon);
		},
		callingIconsAndSelectingIt: function callingIconsAndSelectingIt(_ref5, urlImage) {
			var _this3 = this;

			var dispatch = _ref5.dispatch,
			    state = _ref5.state,
			    commit = _ref5.commit;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var icon;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return dispatch('load');

							case 2:
								icon = searchIconByUrl(urlImage, state.icon.list);

								commit('SET_SELECTED_ICON', icon);

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		}
	},
	getters: {
		iconSelectedId: function iconSelectedId(state) {
			return state.selectedIcon ? state.selectedIcon.id : 0;
		},
		iconSelectedName: function iconSelectedName(state) {
			return state.selectedIcon ? state.selectedIcon.name : '';
		},
		urlIcon: function urlIcon(state) {
			return state.selectedIcon ? state.selectedIcon.urlImage : '';
		}
	},
	mutations: {
		SET_ICON_LIST: function SET_ICON_LIST(state, icons) {
			state.icon.list = icons;
		},
		SET_SELECTED_ICON: function SET_SELECTED_ICON(state, icon) {
			state.selectedIcon = icon;
		}
	},
	state: {
		selectedIcon: null,
		icon: {
			list: []
		}
	}
};
/* harmony default export */ __webpack_exports__["a"] = (iconModule);

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guideline_model_actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guideline_model_mutations__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__valuation_model_actions__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__valuation_model_mutations__ = __webpack_require__(657);








/* harmony default export */ __webpack_exports__["a"] = ({
	mutations: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["H" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_3__guideline_model_mutations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__valuation_model_mutations__["a" /* default */]]),
	actions: Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["H" /* mergeAll */])([__WEBPACK_IMPORTED_MODULE_2__guideline_model_actions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__valuation_model_actions__["a" /* default */]]),
	state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export aclInstance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return praktikoInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pollInstance; });
/* unused harmony export jobEvaluationInstance */
/* unused harmony export uploadInstance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aclInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://acl-dev.makipos.la/api'
});

var praktikoInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://praktiko.makipos.la'
});

var pollInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://poll-engine.makipos.la'
});

var jobEvaluationInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://poll-engine.makipos.la'
});

var uploadInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'undefined'
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = pollInstance;
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$httpPraktiko = praktikoInstance;
	Vue.prototype.$httpUpLoad = uploadInstance;
	Vue.prototype.$httpJobEvaluation = jobEvaluationInstance;
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);



function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return null;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem("praktiko" + '::' + key));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem('' + "praktiko"));
}

function getLocalToken() {
	return localStorage.getItem("praktiko" + '::token');
}

function removeLocalData(key) {
	return localStorage.removeItem("praktiko" + '::' + key);
}

function setLocalData(key, data) {
	return localStorage.setItem("praktiko" + '::' + key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function showDownloadDialog(blob, name, extension) {
	var currentDate = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var methods = {
	debounce: debounce,
	exactDate: exactDate,
	formatDate: formatDate,
	generateBlob: generateBlob,
	getLocalData: getLocalData,
	getLocalStorage: getLocalStorage,
	getLocalToken: getLocalToken,
	removeLocalData: removeLocalData,
	setLocalData: setLocalData,
	showDownloadDialog: showDownloadDialog
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	mainData: {},
	supplies: {
		guidelineModel: {
			hasInformationJobEvaluation: false,
			hasPreviewValues: false,
			verbsSelection: {
				highCommand: {},
				mediumCommand: {},
				lowCommand: {}
			},
			levelSelection: {
				role: {},
				title: {},
				experience: {}
			},
			hierarchyAssignation: [],
			organizationChart: [],
			userForm: {
				jobList: []
			}
		},
		valuationModel: {
			factorList: [],
			degreesList: [],
			selectedFactors: [],
			weighing: {
				selectedFactor: {},
				combinations: []
			},
			degree: {
				selectedFactor: {},
				factorDegrees: {}
			}
		}
	}
});

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bus_app_bus__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__ = __webpack_require__(360);








var LOADER_EVENT = 'app-event-loader-toggle-view';
var LOADER_MESSAGE = 'Praktiko esta asignando las jerarquias.';
var LOADER_MESSAGE_ORGANIZATIONAL_CHART = 'Praktiko esta generando el organizagrama.';

/* harmony default export */ __webpack_exports__["a"] = ({
	getJobValuationStatus: function getJobValuationStatus(_ref) {
		var _this = this;

		var commit = _ref.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref2, status;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$http.get('/polls/JEV');

						case 3:
							_ref2 = _context.sent;
							status = _ref2.status;

							commit('UPDATE_HAS_INFORMATION', status === 200);
							return _context.abrupt('return', true);

						case 9:
							_context.prev = 9;
							_context.t0 = _context['catch'](0);
							throw _context.t0;

						case 12:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this, [[0, 9]]);
		}))();
	},
	updateJobList: function updateJobList(_ref3, jobList) {
		var commit = _ref3.commit;

		commit('UPDATE_LIST', jobList);
	},
	updateJobItem: function updateJobItem(_ref4, job) {
		var commit = _ref4.commit,
		    state = _ref4.state;

		var jobList = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["_3" /* when */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('name', job.name), function () {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, job);
		}), state.supplies.guidelineModel.userForm.jobList);
		commit('UPDATE_LIST', jobList);
	},
	loadJobEvaluationConfig: function loadJobEvaluationConfig(_ref5) {
		var _this2 = this;

		var commit = _ref5.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var JOB_EVALUATION_TOOL_CODE, _ref6, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							JOB_EVALUATION_TOOL_CODE = 'JEV';
							_context2.next = 3;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$http.get('/tools/' + JOB_EVALUATION_TOOL_CODE);

						case 3:
							_ref6 = _context2.sent;
							data = _ref6.data;

							commit('UPDATE_MAIN_DATA', data);

						case 6:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	},
	loadRoles: function loadRoles(_ref7) {
		var _this3 = this;

		var commit = _ref7.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
			var _ref8, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.get('/general-data/ROL');

						case 2:
							_ref8 = _context3.sent;
							data = _ref8.data;

							commit('UPDATE_LEVEL_SELECTION_ROLE', {
								name: 'Rol',
								data: data
							});

						case 5:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3);
		}))();
	},
	loadTitles: function loadTitles(_ref9) {
		var _this4 = this;

		var commit = _ref9.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
			var _ref10, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.get('/general-data/TIT');

						case 2:
							_ref10 = _context4.sent;
							data = _ref10.data;

							commit('UPDATE_LEVEL_SELECTION_TITLE', {
								name: 'Título',
								data: data
							});

						case 5:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4);
		}))();
	},
	loadExperiences: function loadExperiences(_ref11) {
		var _this5 = this;

		var commit = _ref11.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
			var _ref12, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.get('/general-data/EXP');

						case 2:
							_ref12 = _context5.sent;
							data = _ref12.data;

							commit('UPDATE_LEVEL_SELECTION_EXPERIENCE', {
								name: 'Experiencia',
								data: data
							});

						case 5:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, _this5);
		}))();
	},
	loadVerbs: function loadVerbs(_ref13) {
		var _this6 = this;

		var commit = _ref13.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
			var _ref14, data;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.prev = 0;
							_context6.next = 3;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.get('/general-data/VER');

						case 3:
							_ref14 = _context6.sent;
							data = _ref14.data;

							commit('UPDATE_COMMAND_DATA', {
								command: 'highCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["a" /* commandMap */].highCommand), data)
							});
							commit('UPDATE_COMMAND_DATA', {
								command: 'mediumCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["a" /* commandMap */].mediumCommand), data)
							});
							commit('UPDATE_COMMAND_DATA', {
								command: 'lowCommand',
								data: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["r" /* find */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('code', __WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["a" /* commandMap */].lowCommand), data)
							});
							return _context6.abrupt('return', true);

						case 11:
							_context6.prev = 11;
							_context6.t0 = _context6['catch'](0);
							throw new Error(_context6.t0);

						case 14:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, _this6, [[0, 11]]);
		}))();
	},
	getGuidelineModelStatus: function getGuidelineModelStatus(_ref15) {
		var _this7 = this;

		var commit = _ref15.commit;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
			var _ref16, _ref16$data, details, jobs, parsedAssignations, concatAll;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$http.get('/polls/JEV?organizationChart=true');

						case 2:
							_ref16 = _context7.sent;
							_ref16$data = _ref16.data;
							details = _ref16$data.details;
							jobs = _ref16$data.jobs;

							if (details) {
								parsedAssignations = Object(__WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["c" /* parseHierarchyAssignation */])(details);
								concatAll = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["U" /* reduce */])(__WEBPACK_IMPORTED_MODULE_3_ramda__["m" /* concat */], []);

								commit('UPDATE_LIST', concatAll(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["O" /* pluck */])('jobPositions', parsedAssignations)));
								commit('UPDATE_HIERARCHY_ASSIGNATION', parsedAssignations);
							}
							commit('UPDATE_ORGANIZATION_CHART', jobs || []);

						case 8:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, _this7);
		}))();
	},
	assignHierarchy: function assignHierarchy(_ref17) {
		var _this8 = this;

		var state = _ref17.state;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
			var payloadRequest;
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE });
							_context8.prev = 1;
							payloadRequest = Object(__WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["b" /* parseAssignationRequest */])(state);
							_context8.next = 5;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.post('/polles/unique', payloadRequest);

						case 5:
							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							return _context8.abrupt('return', true);

						case 9:
							_context8.prev = 9;
							_context8.t0 = _context8['catch'](1);

							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							throw _context8.t0;

						case 13:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, _this8, [[1, 9]]);
		}))();
	},
	generateOrganizationChart: function generateOrganizationChart(_ref18) {
		var _this9 = this;

		var state = _ref18.state;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: true, message: LOADER_MESSAGE_ORGANIZATIONAL_CHART });
							_context9.prev = 1;
							_context9.next = 4;
							return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$httpPraktiko.post('/polles/unique', Object(__WEBPACK_IMPORTED_MODULE_6__utils_guideline_model_helpers__["d" /* parseOrganizationChart */])(state));

						case 4:
							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							return _context9.abrupt('return', true);

						case 8:
							_context9.prev = 8;
							_context9.t0 = _context9['catch'](1);

							__WEBPACK_IMPORTED_MODULE_5__bus_app_bus__["a" /* default */].$emit(LOADER_EVENT, { show: false });
							throw _context9.t0;

						case 12:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, _this9, [[1, 8]]);
		}))();
	},
	updateAssignation: function updateAssignation(_ref19, _ref20) {
		var state = _ref19.state,
		    commit = _ref19.commit;
		var jobPosition = _ref20.jobPosition,
		    assignationId = _ref20.assignationId;

		var hierarchyAssignation = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["K" /* path */])(['supplies', 'guidelineModel', 'hierarchyAssignation'], state);
		var assignationIndex = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["s" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('id', assignationId), hierarchyAssignation);
		var jobPositionIndex = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["s" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["R" /* propEq */])('id', jobPosition.id), Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["K" /* path */])([assignationIndex, 'jobPositions'], hierarchyAssignation));
		commit('UPDATE_JOB_POSITION_ASSIGNATION', { assignationIndex: assignationIndex, jobPositionIndex: jobPositionIndex, jobPosition: jobPosition });
	}
});

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = ({
	UPDATE_HAS_INFORMATION: function UPDATE_HAS_INFORMATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hasInformationJobEvaluation = payload;
	},
	UPDATE_LIST: function UPDATE_LIST(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.jobList = payload;
	},
	UPDATE_MAIN_DATA: function UPDATE_MAIN_DATA(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.mainData = payload;
	},
	UPDATE_LEVEL_SELECTION_ROLE: function UPDATE_LEVEL_SELECTION_ROLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.role = payload;
	},
	UPDATE_LEVEL_SELECTION_TITLE: function UPDATE_LEVEL_SELECTION_TITLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.title = payload;
	},
	UPDATE_LEVEL_SELECTION_EXPERIENCE: function UPDATE_LEVEL_SELECTION_EXPERIENCE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.experience = payload;
	},
	UPDATE_COMMAND_DATA: function UPDATE_COMMAND_DATA(state, _ref) {
		var command = _ref.command,
		    data = _ref.data;

		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.verbsSelection[command] = data;
	},
	UPDATE_HIERARCHY_ASSIGNATION: function UPDATE_HIERARCHY_ASSIGNATION(state, payload) {
		if (Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["F" /* length */])(payload) > 0) {
			// eslint-disable-next-line no-param-reassign
			state.supplies.guidelineModel.hasPreviewValues = true;
		}
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = payload;
	},
	UPDATE_ORGANIZATION_CHART: function UPDATE_ORGANIZATION_CHART(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.organizationChart = payload;
	},
	UPDATE_JOB_POSITION_ASSIGNATION: function UPDATE_JOB_POSITION_ASSIGNATION(state, _ref2) {
		var assignationIndex = _ref2.assignationIndex,
		    jobPositionIndex = _ref2.jobPositionIndex,
		    jobPosition = _ref2.jobPosition;

		var hierarchyAssignation = state.supplies.guidelineModel.hierarchyAssignation;
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["k" /* assocPath */])([assignationIndex, 'jobPositions', jobPositionIndex], jobPosition, hierarchyAssignation);
	}
});

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_job_evaluation_utils_valuation_model_degree__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(6);







var findIndexFactor = function findIndexFactor(factor, factorList) {
	return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* findIndex */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["R" /* propEq */])('uuid', factor.uuid), factorList);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	updateSelectedFactors: function updateSelectedFactors(_ref, selectedFactors) {
		var commit = _ref.commit;

		var combinations = Object(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["i" /* generateWeighingComparison */])(selectedFactors);
		commit('UPDATE_COMBINATIONS', combinations);
		commit('UPDATE_SELECTED_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["b" /* addWeighWith */])(selectedFactors, combinations));
	},
	updateSelectedFactor: function updateSelectedFactor(_ref2, selectedFactor) {
		var commit = _ref2.commit;

		commit('UPDATE_SELECTED_FACTOR', selectedFactor);
	},
	updateSelectedFactorDegree: function updateSelectedFactorDegree(_ref3, selectedFactor) {
		var commit = _ref3.commit;

		commit('UPDATE_SELECTED_FACTOR_DEGREE', selectedFactor);
	},
	updateFactorInSelectedFactors: function updateFactorInSelectedFactors(_ref4, itemToReplace) {
		var state = _ref4.state,
		    commit = _ref4.commit;

		var selectedFactors = state.supplies.valuationModel.selectedFactors;
		var indexFound = findIndexFactor(itemToReplace, selectedFactors);
		commit('UPDATE_SELECTED_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_1" /* update */])(indexFound, itemToReplace, selectedFactors));
	},
	getFactors: function getFactors(_ref5) {
		var _this = this;

		var state = _ref5.state,
		    commit = _ref5.commit;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _ref6, factors;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["F" /* length */])(state.supplies.valuationModel.factorList) < 1)) {
								_context.next = 6;
								break;
							}

							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=3');

						case 3:
							_ref6 = _context.sent;
							factors = _ref6.data;

							commit('UPDATE_FACTORS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["a" /* addUuidName */], factors));

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	updateCombination: function updateCombination(_ref7, newCombination) {
		var commit = _ref7.commit,
		    state = _ref7.state;

		var currentCombinations = state.supplies.valuationModel.weighing.combinations;
		var sortKeys = function sortKeys(combinationItem) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["X" /* sort */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["d" /* diff */], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["D" /* keys */])(combinationItem));
		};
		var indexFound = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["s" /* findIndex */])(function (combinationItem) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["p" /* equals */])(sortKeys(newCombination), sortKeys(combinationItem));
		}, currentCombinations);
		commit('UPDATE_COMBINATIONS', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["_1" /* update */])(indexFound, newCombination, currentCombinations));
	},
	updateCombinations: function updateCombinations(_ref8, newCombinations) {
		var commit = _ref8.commit;

		commit('UPDATE_COMBINATIONS', newCombinations);
	},
	getDegrees: function getDegrees(_ref9) {
		var _this2 = this;

		var commit = _ref9.commit;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var _ref10, degrees;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.prev = 0;
							_context2.next = 3;
							return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$http.get('/hierarchies/JEV?flagLevel=true&level=4');

						case 3:
							_ref10 = _context2.sent;
							degrees = _ref10.data;

							commit('UPDATE_DEGREES', Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["G" /* map */])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["N" /* pipe */])(__WEBPACK_IMPORTED_MODULE_3__modules_job_evaluation_utils_valuation_model_factors__["a" /* addUuidName */], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["M" /* pick */])(['uuid', 'name', 'code'])), degrees));
							return _context2.abrupt('return', true);

						case 9:
							_context2.prev = 9;
							_context2.t0 = _context2['catch'](0);
							throw _context2.t0;

						case 12:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2, [[0, 9]]);
		}))();
	},
	updateFactorDegrees: function updateFactorDegrees(_ref11, factorDegrees) {
		var commit = _ref11.commit;

		commit('UPDATE_FACTOR_DEGREES', factorDegrees);
	},
	createValuation: function createValuation(_ref12) {
		var _this3 = this;

		var state = _ref12.state;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
			var payloadRequest;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							payloadRequest = Object(__WEBPACK_IMPORTED_MODULE_4__modules_job_evaluation_utils_valuation_model_degree__["e" /* parseRequestValuation */])(state);
							_context3.prev = 1;
							_context3.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$http.post('/polls', payloadRequest);

						case 4:
							return _context3.abrupt('return', true);

						case 7:
							_context3.prev = 7;
							_context3.t0 = _context3['catch'](1);
							throw _context3.t0;

						case 10:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3, [[1, 7]]);
		}))();
	},
	savePayrollProposal: function savePayrollProposal(_, payload) {
		var _this4 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
			var currentPayroll, idealPayroll;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							currentPayroll = payload.currentPayroll, idealPayroll = payload.idealPayroll;
							_context4.prev = 1;
							_context4.next = 4;
							return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$http.patch('/polls/JEV', {
								additionalInformation: {
									currentPayroll: parseFloat(currentPayroll),
									idealPayroll: parseFloat(idealPayroll)
								}
							});

						case 4:
							return _context4.abrupt('return', true);

						case 7:
							_context4.prev = 7;
							_context4.t0 = _context4['catch'](1);
							throw _context4.t0;

						case 10:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4, [[1, 7]]);
		}))();
	}
});

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	UPDATE_SELECTED_FACTORS: function UPDATE_SELECTED_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.selectedFactors = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload));
	},
	UPDATE_SELECTED_FACTOR: function UPDATE_SELECTED_FACTOR(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.selectedFactor = payload;
	},
	UPDATE_FACTORS: function UPDATE_FACTORS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.factorList = payload;
	},
	UPDATE_DEGREES: function UPDATE_DEGREES(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degreesList = payload;
	},
	UPDATE_COMBINATIONS: function UPDATE_COMBINATIONS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.weighing.combinations = payload;
	},
	UPDATE_SELECTED_FACTOR_DEGREE: function UPDATE_SELECTED_FACTOR_DEGREE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.selectedFactor = payload;
	},
	UPDATE_FACTOR_DEGREES: function UPDATE_FACTOR_DEGREES(state, factorDegrees) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.valuationModel.degree.factorDegrees = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.supplies.valuationModel.degree.factorDegrees, factorDegrees);
	}
});

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function clearUser(context) {
	context.commit('clearUser');
}

function toggleLoading(context, value) {
	context.commit('toggleLoading', value);
}

function showSnackBar(context, snackbar) {
	var visibleSnackBar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, snackbar);
	visibleSnackBar.isVisible = true;
	visibleSnackBar.color = visibleSnackBar.color || 'primary';
	context.commit('showSnackBar', visibleSnackBar);
}

function setToken(context, token) {
	context.commit('setToken', token);
}

function setUser(context, user) {
	context.commit('setUser', user);
	context.commit('isEmployee', user.flagAdmin);
}

function setSideBarRoutes(_ref, routes) {
	var commit = _ref.commit;

	commit('SET_SIDE_BAR_ROUTES', routes);
}

var methods = {
	clearUser: clearUser,
	setSideBarRoutes: setSideBarRoutes,
	setToken: setToken,
	setUser: setUser,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function indeterminate(state) {
	return state.appConfig.isLoading;
}

function companyLogo(state) {
	return state.user ? state.user.logo : '';
}

function user(state) {
	return state.user;
}

function userName(state) {
	return state.user ? state.user.name + ' ' + state.user.lastName : '';
}

function token(state) {
	return state.token;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

function themeColors() {
	return JSON.parse(localStorage.getItem("praktiko" + '::theme'));
}

function pollData(state) {
	return state.pollData;
}

function fullName(state) {
	var _state$user = state.user,
	    name = _state$user.name,
	    lastName = _state$user.lastName;

	return name + ' ' + lastName;
}

var methods = {
	companyLogo: companyLogo,
	fullName: fullName,
	indeterminate: indeterminate,
	pollData: pollData,
	snackbar: snackbar,
	themeColors: themeColors,
	token: token,
	user: user,
	userName: userName
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


function clearUser(state) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', null);
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', null);
}

function setToken(state, token) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', token);
}

function setUser(state, user) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', user);
}

function isEmployee(state, flagAdmin) {
	var flag = typeof flagAdmin === 'string' ? Number(flagAdmin) : flagAdmin;
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.user, 'isEmployee', !flag);
}

function showSnackBar(state, snackbar) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'isLoading', value);
}

function UPDATE_POLL_PROGRESS(state, number) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.pollData, 'progress', state.pollData.progress + number);
}

function RESET_POLL_PROGRESS(state) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.pollData, 'progress', 0);
}

function SET_SIDE_BAR_ROUTES(state, routes) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'sideBarRoutes', routes);
}

var methods = {
	clearUser: clearUser,
	isEmployee: isEmployee,
	setToken: setToken,
	setUser: setUser,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading,
	RESET_POLL_PROGRESS: RESET_POLL_PROGRESS,
	SET_SIDE_BAR_ROUTES: SET_SIDE_BAR_ROUTES,
	UPDATE_POLL_PROGRESS: UPDATE_POLL_PROGRESS
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persist__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(31);



var SELECTED_FACTORS_PATH = ['jobEvaluation', 'supplies', 'valuationModel', 'selectedFactors'];
var SELECTED_FACTOR = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'selectedFactor'];
var SELECTED_FACTOR_DEGREE = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'selectedFactor'];
var FACTOR_DEGREES = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'factorDegrees'];
var COMBINATIONS = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'combinations'];

var storeReducer = function storeReducer(state) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["N" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTORS_PATH, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["K" /* path */])(SELECTED_FACTORS_PATH, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTOR, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["K" /* path */])(SELECTED_FACTOR, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(COMBINATIONS, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["K" /* path */])(COMBINATIONS, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(SELECTED_FACTOR_DEGREE, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["K" /* path */])(SELECTED_FACTOR_DEGREE, state)), Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["k" /* assocPath */])(FACTOR_DEGREES, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["K" /* path */])(FACTOR_DEGREES, state)))({});
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex_persist__["a" /* default */]({
	key: 'praktiko:store',
	storage: window.localStorage,
	reducer: storeReducer
}));

/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1349a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(770)
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1349a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 770:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLoader_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3092b990_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLoader_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3092b990"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3092b990_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"main-loader"},[_c('div',{staticClass:"main-loader-content"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return injectCssVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectTextColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(31);


var getColors = function getColors() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["_0" /* tryCatch */])(function (colorString) {
		return JSON.parse(colorString);
	}, Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["f" /* always */])({}))('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success":   "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent":   "#005CAF","error": "#f42b17","warning": "#FFB74C"}');
};

var injectCssVariables = function injectCssVariables() {
	var colors = getColors();
	var root = document.documentElement;
	Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["v" /* forEachObjIndexed */])(function (color, key) {
		root.style.setProperty('--app-color-' + key, color);
	}, colors);
};

var injectTextColors = function injectTextColors() {
	var colors = getColors();
	var style = document.createElement('style');
	var cssTextClasses = '';
	style.type = 'text/css';
	Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["v" /* forEachObjIndexed */])(function (color, key) {
		cssTextClasses += ' .text-' + key + ' { color: ' + color + ' !important; }';
	}, colors);
	style.innerHTML = cssTextClasses;
	document.getElementsByTagName('head')[0].appendChild(style);
};

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.indeterminate)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"color":"success","indeterminate":_vm.indeterminate}}):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('main-loader'),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":5000,"color":_vm.snackbar.color,"top":"","right":""},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_vm._v("\n\t\t"+_vm._s(_vm.snackbar.text)+"\n\t\t"),(_vm.snackbar.html)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.snackbar.html)}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar.isVisible = false}}},[_vm._v("\n\t\t\tCerrar\n\t\t")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput__);











































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default.a, {
		components: {
			VAvatar: __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VAvatar___default.a,
			VAlert: __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default.a,
			VApp: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default.a,
			VAutocomplete: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VAutocomplete___default.a,
			VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a,
			VBtnToggle: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default.a,
			VCheckbox: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default.a,
			VChip: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default.a,
			VCard: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default.a,
			VDataIterator: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default.a,
			VDatePicker: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default.a,
			VDialog: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default.a,
			VDivider: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default.a,
			VForm: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default.a,
			VGrid: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default.a,
			VIcon: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default.a,
			VInput: __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VInput___default.a,
			VList: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default.a,
			VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default.a,
			VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default.a,
			VRadioGroup: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default.a,
			VSelect: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default.a,
			VSlider: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default.a,
			VSnackbar: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default.a,
			VSubheader: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default.a,
			VTextField: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default.a,
			VTimePicker: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default.a,
			VToolbar: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default.a,
			VTooltip: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default.a,
			transitions: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default.a,
			VExpansionPanel: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default.a,
			VDataTable: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default.a,
			VProgressLinear: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default.a,
			VProgressCircular: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VProgressCircular___default.a,
			VTabs: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTabs___default.a,
			VTextarea: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTextarea___default.a,
			VStepper: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default.a,
			VSwitch: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default.a,
			VTreeview: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VTreeview___default.a
		},
		theme: JSON.parse('{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success":   "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent":   "#005CAF","error": "#f42b17","warning": "#FFB74C"}')
	});
});

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 805:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 955:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = httpRequestInterceptor;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseSuccessInterceptor;
/* harmony export (immutable) */ __webpack_exports__["b"] = httpResponseInterceptor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(966);




function httpRequestInterceptor(config) {
	var headers = config.headers;
	if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token) {
		headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token;
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else if (config.url === 'external-api/password/email' || config.url === 'external-api/password/reset') {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

function httpResponseSuccessInterceptor(response) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	return response;
}

function httpResponseInterceptor(error) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	var text = 'Su sesión expiró.';
	var status = error.response.status;
	var loginRoute = { name: 'login' };
	if (status === 401 && this.$route.name !== 'reset-password') {
		this.$router.push(loginRoute);
	} else if (status === 400) {
		text = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["a" /* default */])(error.response);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción';
	} else if (status === 500) {
		text = 'No se logró completar la acción, intente de nuevo.';
	}
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('showSnackBar', { text: text, color: 'error' });
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
}

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (code) {
	if (code === 'USER_EXISTS') {
		return 'El usuario ya existe';
	}
	return 'Verifique que completó los datos requeridos';
});

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_configuration__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polls__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__diagnosis__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_job_evaluation_router__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__awards__ = __webpack_require__(984);









/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);
	var config = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'page-home',
			component: function component() {
				return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1071));
			},
			redirect: 'working-environment',
			meta: {
				title: 'Clima Laboral'
			},
			children: [{
				name: 'working-environment',
				path: 'working-environment',
				component: function component() {
					return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1072));
				},
				redirect: 'working-environment/surveys',
				meta: {
					title: 'Clima Laboral'
				},
				props: true,
				children: [{
					name: 'working-environment-surveys',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1073));
					},
					meta: {
						title: 'Clima Laboral'
					},
					children: [{
						name: 'working-environment-surveys-new',
						path: 'new',
						component: function component() {
							return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1074));
						},
						meta: {
							title: 'Clima Laboral'
						}
					}]
				}]
			}, {
				name: 'organizational-diagnosis',
				path: 'organizational',
				component: function component() {
					return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1075));
				},
				meta: {
					title: 'Diagnóstico Organizacional Praktiko'
				},
				props: true,
				children: [{
					name: 'surveys-organizational-diagnosis',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1076));
					},
					meta: {
						title: 'Diagnóstico Organizacional Praktiko'
					}
				}, {
					name: 'new-organizational-diagnosis',
					path: 'new',
					component: function component() {
						return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1077));
					},
					meta: {
						title: 'Diagnóstico Organizacional Praktiko'
					}
				}]
			}, {
				name: 'culture-inventory',
				path: 'inventory',
				component: function component() {
					return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1078));
				},
				meta: {
					title: 'Inventario de Cultura Organizacional'
				},
				props: true,
				children: [{
					name: 'surveys-inventory',
					path: 'surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1079));
					},
					meta: {
						title: 'Inventario de Cultura Organizacional'
					}
				}, {
					name: 'new-inventory',
					path: 'new-surveys',
					component: function component() {
						return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1080));
					},
					meta: {
						title: 'Inventario de Cultura Organizacional'
					}
				}]
			}, __WEBPACK_IMPORTED_MODULE_4__diagnosis__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__polls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__router_configuration__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_job_evaluation_router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__awards__["a" /* default */]]
		}, {
			path: '/reset-password',
			name: 'reset-password',
			meta: {
				title: 'Recuperar Contraseña'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1081));
			}
		}, __WEBPACK_IMPORTED_MODULE_2__login__["a" /* default */]]
	});
	config.beforeEach(function (to, from, next) {
		if (to.name !== 'login') {
			var token = window.localStorage.getItem("praktiko" + '::token');
			if (token || to.name === 'reset-password') {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
});

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_configuration_tools__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_configuration_types__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_configuration_presents__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_configuration_answers__ = __webpack_require__(975);





var configurationRoute = {
	name: 'configuration',
	path: 'configuration',
	component: function component() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1036));
	},
	meta: {
		title: 'Configuración'
	},
	props: true,
	children: [{
		name: 'employees',
		path: 'employees',
		component: function component() {
			return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1037));
		},
		meta: {
			title: 'Configuración'
		},
		children: [{
			name: 'present-assignment',
			path: 'presents/:employeeId',
			components: {
				presentAssignment: function presentAssignment() {
					return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1038));
				}
			}
		}]
	}, {
		name: 'areas',
		path: 'areas',
		component: function component() {
			return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1039));
		},
		meta: {
			title: 'Configuración'
		}
	}, __WEBPACK_IMPORTED_MODULE_1__router_configuration_types__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router_configuration_presents__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__router_configuration_tools__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router_configuration_answers__["a" /* default */]]
};
/* harmony default export */ __webpack_exports__["a"] = (configurationRoute);

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toolsRoute = {
	name: 'tools',
	path: 'tools',
	redirect: 'tools/list',
	meta: {
		title: 'Herramientas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1026));
	},
	children: [{
		name: 'tools-list',
		path: 'list',
		meta: {
			title: 'Listado de herramientas'
		},
		components: {
			toolList: function toolList() {
				return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1027));
			}
		},
		children: [{
			name: 'levels-tool',
			path: ':toolCode/:toolId/levels',
			meta: {
				title: 'Niveles'
			},
			components: {
				toolType: function toolType() {
					return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1028));
				}
			},
			children: [{
				name: 'new-type-form',
				path: 'new-type',
				components: {
					newType: function newType() {
						return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1029));
					}
				}
			}, {
				name: 'new-level-form',
				path: 'new-level/:number/:hierarchyFatherId?/:id?/:name?/:flagQuestion?',
				components: {
					newLevel: function newLevel() {
						return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1030));
					}
				},
				props: true
			}]
		}, {
			name: 'new-tool',
			path: 'new',
			meta: {
				title: 'Nueva Herramienta'
			},
			components: {
				newToolForm: function newToolForm() {
					return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 366));
				}
			},
			children: [{
				name: 'tool-type',
				path: 'type',
				meta: {
					title: 'Tipo de herramienta'
				},
				components: {
					toolType: function toolType() {
						return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 367));
					}
				}
			}, {
				name: 'tool-icons',
				path: 'icons/:type',
				meta: {
					title: 'Seleccionar ícono'
				},
				components: {
					toolIcons: function toolIcons() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 73));
					}
				}
			}, {
				name: 'answer-selection',
				path: 'answer-selection',
				meta: {
					title: 'Tipo de respuesta'
				},
				components: {
					answerSelection: function answerSelection() {
						return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 368));
					}
				}
			}]
		}, {
			name: 'edit-tool',
			path: 'edit/:code',
			meta: {
				title: 'Edición de Herramienta'
			},
			components: {
				newToolForm: function newToolForm() {
					return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 366));
				}
			},
			children: [{
				name: 'tool-type',
				path: 'type',
				meta: {
					title: 'Tipo de herramienta'
				},
				components: {
					toolType: function toolType() {
						return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 367));
					}
				}
			}, {
				name: 'tool-icons',
				path: 'icons/:type',
				meta: {
					title: 'Seleccionar ícono'
				},
				components: {
					toolIcons: function toolIcons() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 73));
					}
				}
			}, {
				name: 'answer-selection',
				path: 'answer-selection',
				meta: {
					title: 'Tipo de respuesta'
				},
				components: {
					answerSelection: function answerSelection() {
						return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 368));
					}
				}
			}]
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (toolsRoute);

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"width":_vm.width,"right":"","temporary":"","fixed":"","stateless":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('section',{staticClass:"header-modal",style:(("background-color: " + _vm.headerColor + ";border:1px solid " + (_vm.$appColors.info) + ";"))},[_c('header',{staticClass:"header-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":_vm.isLoading},on:{"click":_vm.closeDrawer}},[(_vm.imgSrc)?_c('img',{attrs:{"src":_vm.imgSrc,"alt":"Cerrar Filtro","width":"20"}}):_c('v-icon',[_vm._v("arrow_forward")])],1)],1)]),_vm._v(" "),_c('section',{staticClass:"content-modal"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var typeRoute = {
	name: 'level-types',
	path: 'level-types',
	component: function component() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1031));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (typeRoute);

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var presentsRoute = {
	name: 'award',
	path: 'award',
	component: function component() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1032));
	},
	meta: {
		title: 'Lista de regalos'
	},
	children: [{
		name: 'new-present',
		path: 'new',
		meta: {
			title: 'Nuevo Regalo'
		},
		components: {
			newPresentForm: function newPresentForm() {
				return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1033));
			}
		},
		children: [{
			name: 'present-icons',
			path: 'icons/:type',
			meta: {
				title: 'Selecciona ícono'
			},
			components: {
				selectingIcon: function selectingIcon() {
					return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 73));
				}
			}
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (presentsRoute);

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var answerRoute = {
	name: 'answers',
	path: 'answers',
	meta: {
		title: 'Respuestas'
	},
	redirect: 'answers/list',
	component: function component() {
		return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1034));
	},
	children: [{
		name: 'list',
		path: 'list',
		meta: {
			title: 'Listado de respuestas'
		},
		components: {
			answerList: function answerList() {
				return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1035));
			}
		},
		children: [{
			name: 'new-answer',
			path: 'new',
			meta: {
				title: 'Nueva respuesta'
			},
			components: {
				answerNew: function answerNew() {
					return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 369));
				}
			},
			children: [{
				name: 'answer-icon',
				path: 'answer-icon/:index/:type',
				components: {
					modalAnswerIcon: function modalAnswerIcon() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 73));
					}
				}
			}]
		}, {
			name: 'edit-answer',
			path: 'edit/:id',
			meta: {
				title: 'Edición de respuesta'
			},
			components: {
				answerEdit: function answerEdit() {
					return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 369));
				}
			},
			children: [{
				name: 'answer-icon',
				path: 'answer-icon/:index/:type',
				components: {
					modalAnswerIcon: function modalAnswerIcon() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 73));
					}
				}
			}]
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (answerRoute);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/login/:token?',
	name: 'login',
	meta: {
		title: 'Iniciar Sesión'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1040));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'survey',
	path: 'survey',
	meta: {
		title: 'Encuestas'
	},
	redirect: 'survey/list',
	component: function component() {
		return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1041));
	},
	children: [{
		name: 'survey-list',
		path: 'list',
		component: function component() {
			return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1042));
		},
		meta: {
			title: 'Listado de Encuestas'
		},
		props: true,
		children: [{
			name: 'page-polls',
			path: ':id',
			meta: {
				title: 'Resolver encuesta'
			},
			components: {
				pollResolve: function pollResolve() {
					return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1043));
				}
			}
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'diagnosis',
	path: 'diagnosis',
	component: function component() {
		return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1044));
	},
	meta: {
		title: 'Diagnóstico'
	},
	props: true,
	children: [{
		name: 'diagnoses',
		path: 'diagnoses',
		component: function component() {
			return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1045));
		},
		meta: {
			title: 'Diagnóstico'
		},
		props: true,
		children: [{
			name: 'detail-diagnoses',
			path: ':toolId?/detail/:id',
			component: function component() {
				return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1046));
			},
			meta: {
				title: 'Diagnóstico'
			},
			props: true,
			children: [{
				name: 'detail-summary-inventory',
				path: ':toolId?/inventory/:idsummary',
				component: function component() {
					return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1047));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}, {
				name: 'detail-diagnosis-weather',
				path: ':toolId?/weather/:idsummary',
				component: function component() {
					return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1048));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}, {
				name: 'detail-summary-diagnoses',
				path: ':toolId?/diagnoses/:detailId',
				component: function component() {
					return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1049));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}, {
				name: 'detail-summary-graphic-inventory',
				path: ':toolId?/graphic-inventory/:idsummary',
				component: function component() {
					return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1050));
				},
				meta: {
					title: 'Diagnóstico'
				},
				props: true
			}]
		}]
	}, {
		name: 'new-diagnosis',
		path: 'new-diagnosis/:toolCode?/:pollId?',
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1051));
		},
		meta: {
			title: 'Diagnóstico'
		}
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'job-evaluation',
	path: 'job-evaluation',
	component: function component() {
		return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1052));
	},
	meta: {
		title: 'Valoración de Puestos'
	},
	props: true,
	redirect: '/job-evaluation/onboarding',
	children: [{
		name: 'job-evaluation-onboarding',
		path: 'onboarding',
		component: function component() {
			return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1053));
		}
	}, {
		name: 'job-evaluation-new',
		path: 'new',
		component: function component() {
			return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1054));
		},
		children: [{
			name: 'job-evaluation-supplies',
			path: 'supplies',
			component: function component() {
				return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1055));
			},
			meta: {
				title: 'Insumos'
			},
			children: [{
				name: 'job-supply-guideline-model',
				path: 'guideline-model',
				component: function component() {
					return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1056));
				},
				meta: {
					title: 'Modelo Directriz'
				}
			}, {
				name: 'job-supply-guideline-model-hierarchy',
				path: 'guideline-model-hierarchy',
				component: function component() {
					return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1057));
				},
				meta: {
					title: 'Modelo Directriz'
				}
			}, {
				name: 'job-supply-organization-chart',
				path: 'organization-chart',
				component: function component() {
					return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1058));
				},
				meta: {
					title: 'Organigrama'
				}
			}, {
				name: 'job-supply-valuation-model',
				path: 'valuation-model',
				component: function component() {
					return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1059));
				},
				meta: {
					title: 'Modelo de Valoración'
				},
				redirect: '/job-evaluation/new/supplies/valuation-model/factors-choice',
				children: [{
					name: 'job-supply-valuation-model-factors-choice',
					path: 'factors-choice',
					component: function component() {
						return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1060));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-factors-weighting',
					path: 'factors-weighting',
					component: function component() {
						return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1061));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-degrees',
					path: 'degrees',
					component: function component() {
						return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1062));
					},
					meta: {
						title: 'Nuevo'
					}
				}, {
					name: 'job-supply-valuation-model-payroll-proposal',
					path: 'payroll-proposal',
					component: function component() {
						return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1063));
					},
					meta: {
						title: 'Nuevo'
					}
				}]
			}]
		}, {
			name: 'job-evaluation-processes',
			path: 'processes',
			component: function component() {
				return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1064));
			},
			meta: {
				title: 'Procesos'
			},
			children: [{
				name: 'job-evaluation-processes-commitees',
				path: 'organize-committee',
				component: function component() {
					return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1065));
				},
				meta: {
					title: 'Comités'
				},
				children: [{
					name: 'new-commitees',
					path: 'new/:name?/:id?',
					components: {
						newCommiteeForm: function newCommiteeForm() {
							return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1066));
						}
					},
					meta: {
						title: 'Nuevo Comité'
					}
				}]
			}]
		}]
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'profile',
	path: 'profile',
	component: function component() {
		return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1067));
	},
	meta: {
		title: 'Perfil',
		logo: '/static/img/sidebar/users.svg'
	},
	children: [{
		name: 'profile-edit',
		path: 'edit',
		components: {
			profileEdit: function profileEdit() {
				return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1068));
			}
		},
		meta: {
			title: 'Editar Perfil',
			logo: '/static/img/sidebar/users.svg'
		}
	}, {
		name: 'password-edit',
		path: 'password',
		components: {
			passwordEdit: function passwordEdit() {
				return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1069));
			}
		},
		meta: {
			title: 'Contraseña',
			logo: '/static/img/sidebar/users.svg'
		}
	}]
};
/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var awardsRoute = {
	name: '',
	path: 'awards',
	component: function component() {
		return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1070));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (awardsRoute);

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"media-print main-header-page align-center",class:{ 'toggle': _vm.isVisible },attrs:{"app":"","height":"40"}},[_c('button',{staticClass:"btn-toggle d-flex",on:{"click":function($event){_vm.$emit('open')}}},[_c('img',{attrs:{"src":"/static/img/toggle.svg","alt":"","height":"14","width":"19"}})]),_vm._v(" "),_vm._l((_vm.breadCrumbs),function(route,indexRoute){return _c('div',{key:indexRoute,staticClass:"d-flex",style:(("color:" + (_vm.$appColors.info)))},[(route.name === _vm.$route.name || indexRoute === 0)?_c('h1',{staticClass:"header-page-title"},[_vm._v("\n\t\t\t"+_vm._s(route.meta.title)+"\n\t\t")]):[(route.meta.title)?_c('router-link',{staticClass:"header-page-title",style:(("color:" + (_vm.$appColors.primary) + ";text-decoration:none")),attrs:{"to":{ name: route.name }}},[_vm._v(_vm._s(route.meta.title))]):_vm._e(),_vm._v(" "),(_vm.breadCrumbs.length !== indexRoute + 1)?_c('div',{staticClass:"mx-2"}):_vm._e()]],2)}),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"logout-btn",attrs:{"slot":"activator","icon":""},on:{"click":_vm.logout},slot:"activator"},[_c('img',{attrs:{"src":"/static/img/login/logout.svg","alt":"Log out"}})]),_vm._v(" "),_c('span',[_vm._v("Cerrar Sesión")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"sidebar-border media-print",style:(("background-color:" + (_vm.$appColors.white))),attrs:{"app":"","hide-overlay":"","fixed":"","stateless":"","height":"100vh","mini-variant":_vm.mini,"width":"200"},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{style:(("background-color:" + (_vm.$appColors.white))),attrs:{"flatd":""}},[_c('v-list',{staticClass:"bars-align"},[_c('v-list-tile',{staticClass:"logo-company"},[_c('img',{staticClass:"logo-open",attrs:{"src":_vm.company.logoOpen,"alt":"logo compañia"}}),_vm._v(" "),_c('img',{staticClass:"logo-close",attrs:{"src":_vm.company.logoClose,"alt":"logo compañia"}})]),_vm._v(" "),_c('v-list-tile-avatar',{staticClass:"avatar-image"},[_c('img',{staticClass:"icon-avatar",attrs:{"src":_vm.avatar},on:{"click":_vm.goToUser}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"avatar-name"},[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"avatar-position"},[_vm._v(_vm._s(_vm.user.position))])],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"py-0 sidebar-bg mgt-1",style:(("background-color:" + (_vm.$appColors.sidebar)))},_vm._l((_vm.items),function(item){return _c('v-list-group',{key:item.id,attrs:{"no-action":""}},[(item.resource.data.length === 0)?_c('v-list-tile',{class:{ 'v-list__group__header--active' : item.name === _vm.$route.meta.title },attrs:{"slot":"activator","to":item.uri,"color":"secondary","active-class":"white--text"},slot:"activator"},[_c('div',{staticClass:"item-select",style:(("background-color:" + (_vm.$appColors.secondary) + " !important"))}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1)],1):_c('v-list-tile',{staticClass:"padding-items",class:{ 'v-list__group__header--active' : item.name === _vm.$route.meta.title },attrs:{"slot":"activator","color":"white"},slot:"activator"},[_c('div',{staticClass:"item-select",style:(("background-color:" + (_vm.$appColors.secondary) + " !important"))}),_vm._v(" "),_c('v-list-tile-action',{staticClass:"item-action-sidebar"},[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":item.pathIcon},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"ml-2 body-2 bold"},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1),_vm._v(" "),_vm._l((item.resource.data),function(subItem){return _c('v-list-tile',{key:subItem.uri,staticClass:"resources-items",class:{ 'item-sidebar-active' : _vm.$route.name === subItem.uri },attrs:{"to":{ name: subItem.uri },"color":"secondary","active-class":"white--text"}},[_c('v-list-tile-action',{staticClass:"item-action-sidebar"},[_c('v-tooltip',{attrs:{"right":""}},[_c('img',{attrs:{"slot":"activator","src":subItem.iconUrl},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(subItem.name))])])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.name))])],1)],1)})],2)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);




var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		var _ref2, records, headers;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get(url, { params: this.params });

					case 2:
						_ref2 = _context.sent;
						records = _ref2.data;
						headers = _ref2.headers;

						this.table.lastPage = Number(headers['x-last-page']);
						this.table.rows = records.map(function (record) {
							var newRecord = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, record);
							newRecord.isSelected = false;
							return newRecord;
						});
						return _context.abrupt('return', { records: records, headers: headers });

					case 8:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

function data() {
	return {
		params: {
			customerId: null,
			page: 1,
			limit: 20,
			search: null
		},
		table: {
			lastPage: 1,
			rows: []
		}
	};
}

function goTo(name, options) {
	this.$router.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ name: name }, options));
}

function getImageUrl(imageUrl) {
	return this.$imageUrl + '/' + imageUrl;
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.params.page = 1;
	this.loadData(url);
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text) {
	var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
	var html = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	this.$store.dispatch('showSnackBar', { text: text, color: color, html: html });
}

function showGenericError() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ups, ocurrió algún problema';

	this.showNotification(text, 'error');
}

function showRow(columns, columnId) {
	var column = columns.find(function (h) {
		return h.id === columnId;
	});
	return column.visible;
}

function token() {
	return this.$store.getters.token;
}

function stopClick() {
	return false;
}

function isAdmin() {
	return Number(this.$store.getters.user.flagAdmin) === 1;
}

var mixin = {
	data: data,
	computed: {
		isAdmin: isAdmin,
		token: token
	},
	methods: {
		getImageUrl: getImageUrl,
		goTo: goTo,
		loadData: loadData,
		onSearch: onSearch,
		replaceString: replaceString,
		showGenericError: showGenericError,
		showNotification: showNotification,
		showRow: showRow,
		stopClick: stopClick
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	var cutText = value.substring(0, length);
	return cutText + '...';
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return '';
}

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('exactDate', exactDate);
	Vue.filter('formatDate', formatDate);
});

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_date_mask__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_table_app_table__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_app_tooltip_button__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_header_page__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_form_sidebar__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_utils_modal_sidebar_button__ = __webpack_require__(1021);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-login', __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-admin', __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-date-mask', __WEBPACK_IMPORTED_MODULE_4__components_shared_app_date_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-table', __WEBPACK_IMPORTED_MODULE_5__components_shared_table_app_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-tooltip-button', __WEBPACK_IMPORTED_MODULE_6__components_shared_app_tooltip_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('header-page', __WEBPACK_IMPORTED_MODULE_7__components_shared_header_page__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('general-filter', __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('form-sidebar', __WEBPACK_IMPORTED_MODULE_8__components_shared_form_sidebar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal-sidebar-button', __WEBPACK_IMPORTED_MODULE_9__components_shared_utils_modal_sidebar_button__["a" /* default */]);

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__ = __webpack_require__(995);
function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2496fe80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 994:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352edfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__ = __webpack_require__(1000);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352edfb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_subheader_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446b61c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_subheader_vue__ = __webpack_require__(999);
function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7446b61c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_subheader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7446b61c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_subheader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 998:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"media-print",attrs:{"app":"","height":_vm.heightToolbar}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[371]);


// WEBPACK FOOTER //
// static/js/app.9065eea48e84a72b8f1e.js